// Countries data (simplified - using country codes as values)
const COUNTRIES_BY_CODE = {
    'Af': 'Afghanistan',
    'Al': 'Albania',
    'Dz': 'Algeria',
    'As': 'American Samoa',
    'Ad': 'Andorra',
    'Ao': 'Angola',
    'Ai': 'Anguilla',
    'Aq': 'Antarctica',
    'Ag': 'Antigua and Barbuda',
    'Ar': 'Argentina',
    'Am': 'Armenia',
    'Aw': 'Aruba',
    'Au': 'Australia',
    'At': 'Austria',
    'Az': 'Azerbaijan',
    'Bs': 'Bahamas (the)',
    'Bh': 'Bahrain',
    'Bd': 'Bangladesh',
    'Bb': 'Barbados',
    'By': 'Belarus',
    'Be': 'Belgium',
    'Bz': 'Belize',
    'Bj': 'Benin',
    'Bm': 'Bermuda',
    'Bt': 'Bhutan',
    'Bo': 'Bolivia (Plurinational State of)',
    'Bq': 'Bonaire, Sint Eustatius and Saba',
    'Ba': 'Bosnia and Herzegovina',
    'Bw': 'Botswana',
    'Bv': 'Bouvet Island',
    'Br': 'Brazil',
    'Io': 'British Indian Ocean Territory (the)',
    'Bn': 'Brunei Darussalam',
    'Bg': 'Bulgaria',
    'Bf': 'Burkina Faso',
    'Bi': 'Burundi',
    'Cv': 'Cabo Verde',
    'Kh': 'Cambodia',
    'Cm': 'Cameroon',
    'Ca': 'Canada',
    'Ky': 'Cayman Islands (the)',
    'Cf': 'Central African Republic (the)',
    'Td': 'Chad',
    'Cl': 'Chile',
    'Cn': 'China',
    'Cx': 'Christmas Island',
    'Cc': 'Cocos (Keeling) Islands (the)',
    'Co': 'Colombia',
    'Km': 'Comoros (the)',
    'Cd': 'Congo (the Democratic Republic of the)',
    'Cg': 'Congo (the)',
    'Ck': 'Cook Islands (the)',
    'Cr': 'Costa Rica',
    'Hr': 'Croatia',
    'Cu': 'Cuba',
    'Cw': 'Curaçao',
    'Cy': 'Cyprus',
    'Cz': 'Czechia',
    'Ci': 'Côte d\'Ivoire',
    'Dk': 'Denmark',
    'Dj': 'Djibouti',
    'Dm': 'Dominica',
    'Do': 'Dominican Republic (the)',
    'Ec': 'Ecuador',
    'Eg': 'Egypt',
    'Sv': 'El Salvador',
    'Gq': 'Equatorial Guinea',
    'Er': 'Eritrea',
    'Ee': 'Estonia',
    'Sz': 'Eswatini',
    'Et': 'Ethiopia',
    'Fk': 'Falkland Islands (the) [Malvinas]',
    'Fo': 'Faroe Islands (the)',
    'Fj': 'Fiji',
    'Fi': 'Finland',
    'Fr': 'France',
    'Gf': 'French Guiana',
    'Pf': 'French Polynesia',
    'Tf': 'French Southern Territories (the)',
    'Ga': 'Gabon',
    'Gm': 'Gambia (the)',
    'Ge': 'Georgia',
    'De': 'Germany',
    'Gh': 'Ghana',
    'Gi': 'Gibraltar',
    'Gr': 'Greece',
    'Gl': 'Greenland',
    'Gd': 'Grenada',
    'Gp': 'Guadeloupe',
    'Gu': 'Guam',
    'Gt': 'Guatemala',
    'Gg': 'Guernsey',
    'Gn': 'Guinea',
    'Gw': 'Guinea-Bissau',
    'Gy': 'Guyana',
    'Ht': 'Haiti',
    'Hm': 'Heard Island and McDonald Islands',
    'Va': 'Holy See (the)',
    'Hn': 'Honduras',
    'Hk': 'Hong Kong',
    'Hu': 'Hungary',
    'Is': 'Iceland',
    'In': 'India',
    'Id': 'Indonesia',
    'Ir': 'Iran (Islamic Republic of)',
    'Iq': 'Iraq',
    'Ie': 'Ireland',
    'Im': 'Isle of Man',
    'Il': 'Israel',
    'It': 'Italy',
    'Jm': 'Jamaica',
    'Jp': 'Japan',
    'Je': 'Jersey',
    'Jo': 'Jordan',
    'Kz': 'Kazakhstan',
    'Ke': 'Kenya',
    'Ki': 'Kiribati',
    'Kp': 'Korea (the Democratic People\'s Republic of)',
    'Kr': 'Korea (the Republic of)',
    'Kw': 'Kuwait',
    'Kg': 'Kyrgyzstan',
    'La': 'Lao People\'s Democratic Republic (the)',
    'Lv': 'Latvia',
    'Lb': 'Lebanon',
    'Ls': 'Lesotho',
    'Lr': 'Liberia',
    'Ly': 'Libya',
    'Li': 'Liechtenstein',
    'Lt': 'Lithuania',
    'Lu': 'Luxembourg',
    'Mo': 'Macao',
    'Mg': 'Madagascar',
    'Mw': 'Malawi',
    'My': 'Malaysia',
    'Mv': 'Maldives',
    'Ml': 'Mali',
    'Mt': 'Malta',
    'Mh': 'Marshall Islands (the)',
    'Mq': 'Martinique',
    'Mr': 'Mauritania',
    'Mu': 'Mauritius',
    'Yt': 'Mayotte',
    'Mx': 'Mexico',
    'Fm': 'Micronesia (Federated States of)',
    'Md': 'Moldova (the Republic of)',
    'Mc': 'Monaco',
    'Mn': 'Mongolia',
    'Me': 'Montenegro',
    'Ms': 'Montserrat',
    'Ma': 'Morocco',
    'Mz': 'Mozambique',
    'Mm': 'Myanmar',
    'Na': 'Namibia',
    'Nr': 'Nauru',
    'Np': 'Nepal',
    'Nl': 'Netherlands (the)',
    'Nc': 'New Caledonia',
    'Nz': 'New Zealand',
    'Ni': 'Nicaragua',
    'Ne': 'Niger (the)',
    'Ng': 'Nigeria',
    'Nu': 'Niue',
    'Nf': 'Norfolk Island',
    'Mp': 'Northern Mariana Islands (the)',
    'No': 'Norway',
    'Om': 'Oman',
    'Pk': 'Pakistan',
    'Pw': 'Palau',
    'Ps': 'Palestine, State of',
    'Pa': 'Panama',
    'Pg': 'Papua New Guinea',
    'Py': 'Paraguay',
    'Pe': 'Peru',
    'Ph': 'Philippines (the)',
    'Pn': 'Pitcairn',
    'Pl': 'Poland',
    'Pt': 'Portugal',
    'Pr': 'Puerto Rico',
    'Qa': 'Qatar',
    'Mk': 'Republic of North Macedonia',
    'Ro': 'Romania',
    'Ru': 'Russian Federation (the)',
    'Rw': 'Rwanda',
    'Re': 'Réunion',
    'Bl': 'Saint Barthélemy',
    'Sh': 'Saint Helena, Ascension and Tristan da Cunha',
    'Kn': 'Saint Kitts and Nevis',
    'Lc': 'Saint Lucia',
    'Mf': 'Saint Martin (French part)',
    'Pm': 'Saint Pierre and Miquelon',
    'Vc': 'Saint Vincent and the Grenadines',
    'Ws': 'Samoa',
    'Sm': 'San Marino',
    'St': 'Sao Tome and Principe',
    'Sa': 'Saudi Arabia',
    'Sn': 'Senegal',
    'Rs': 'Serbia',
    'Sc': 'Seychelles',
    'Sl': 'Sierra Leone',
    'Sg': 'Singapore',
    'Sx': 'Sint Maarten (Dutch part)',
    'Sk': 'Slovakia',
    'Si': 'Slovenia',
    'Sb': 'Solomon Islands',
    'So': 'Somalia',
    'Za': 'South Africa',
    'Gs': 'South Georgia and the South Sandwich Islands',
    'Ss': 'South Sudan',
    'Es': 'Spain',
    'Lk': 'Sri Lanka',
    'Sd': 'Sudan (the)',
    'Sr': 'Suriname',
    'Sj': 'Svalbard and Jan Mayen',
    'Se': 'Sweden',
    'Ch': 'Switzerland',
    'Sy': 'Syrian Arab Republic',
    'Tw': 'Taiwan',
    'Tj': 'Tajikistan',
    'Tz': 'Tanzania, United Republic of',
    'Th': 'Thailand',
    'Tl': 'Timor-Leste',
    'Tg': 'Togo',
    'Tk': 'Tokelau',
    'To': 'Tonga',
    'Tt': 'Trinidad and Tobago',
    'Tn': 'Tunisia',
    'Tr': 'Turkey',
    'Tm': 'Turkmenistan',
    'Tc': 'Turks and Caicos Islands (the)',
    'Tv': 'Tuvalu',
    'Ug': 'Uganda',
    'Ua': 'Ukraine',
    'Ae': 'United Arab Emirates (the)',
    'Gb': 'United Kingdom of Great Britain and Northern Ireland (the)',
    'Um': 'United States Minor Outlying Islands (the)',
    'Us': 'United States of America (the)',
    'Uy': 'Uruguay',
    'Uz': 'Uzbekistan',
    'Vu': 'Vanuatu',
    'Ve': 'Venezuela (Bolivarian Republic of)',
    'Vn': 'Viet Nam',
    'Vg': 'Virgin Islands (British)',
    'Vi': 'Virgin Islands (U.S.)',
    'Wf': 'Wallis and Futuna',
    'Eh': 'Western Sahara',
    'Ye': 'Yemen',
    'Zm': 'Zambia',
    'Zw': 'Zimbabwe',
    'Ax': 'Åland Islands'
};

// Form state
const TOTAL_STEPS = document.querySelectorAll('.form-step').length;
let currentStep = 1;
const STORAGE_KEY = 'briefFormData';
const LOGGED_IN_CUSTOMER_ID = null;

// DOM Elements
const form = document.getElementById('brief-form');
const backBtn = document.getElementById('back-btn');
const nextBtn = document.getElementById('next-btn');
const submitBtn = document.getElementById('submit-btn');
const closeBtn = document.getElementById('close-btn');
const closeBtnDesktop = document.getElementById('close-btn-desktop');
const countrySelect = document.getElementById('country');
const supplying_my_own_shoe = document.querySelector('input[name="supplying_my_own_shoe"]:checked');
const shoe_type_other_opt = document.getElementById('shoe_type_other_int');
const countrySelectWrapper = countrySelect ? countrySelect.closest('.country-select-wrapper') : null;
const nameInput = document.getElementById('name');
const emailInput = document.getElementById('email');

// Step 2 fields
const selectedSneakerInput = document.getElementById('selected-sneaker');
const sneakerTypeSelect = document.getElementById('sneaker-type');
const sneakerCategorySelect = document.getElementById('sneaker-category');
const sneakerCategoryField = document.getElementById('sneaker-category-field');
const sneakerBrandSelect = document.getElementById('sneaker-brand');
const sneakerBrandField = document.getElementById('sneaker-brand-field');
const sneakerSilhouetteSelect = document.getElementById('sneaker-silhouette');
const sneakerSilhouetteField = document.getElementById('sneaker-silhouette-field');
const sneakerGrid = document.getElementById('sneaker-grid');
// Category/Brand label elements (we will swap the category label to 'Brand' when type dictates)
const sneakerCategoryLabelEl = document.querySelector('#sneaker-category-field .form-label');
const sneakerBrandLabelEl = document.querySelector('#sneaker-brand-field .form-label');
const initialCategoryLabelText = sneakerCategoryLabelEl ? sneakerCategoryLabelEl.textContent.trim() : 'Category';
const brandLabelText = sneakerBrandLabelEl ? sneakerBrandLabelEl.textContent.trim() : 'Brand';
const sneakerTypePlaceholder = getSelectPlaceholderText(sneakerTypeSelect);
const sneakerCategoryPlaceholder = sneakerCategorySelect ? getSelectPlaceholderText(sneakerCategorySelect) : 'Select Category';
const sneakerBrandPlaceholder = getSelectPlaceholderText(sneakerBrandSelect);
const sneakerSilhouettePlaceholder = getSelectPlaceholderText(sneakerSilhouetteSelect);


// Step 3 fields
const colorSelect = document.getElementById('color');
const colorOtherInput = document.getElementById('color-other');
const preferencesBudgetSelect = document.getElementById('preferences-budget');
const genderSelect = document.getElementById('gender');
const sizeField = document.getElementById('size-field');
const sizeSelect = document.getElementById('size');
const themeSelect = document.getElementById('theme');
const subthemeSelect = document.getElementById('subtheme');
const subthemeField = document.getElementById('subtheme-field');

// Step 4 fields
const additionalTextTextarea = document.getElementById('additional-text');
const fileUploadInput = document.getElementById('file-upload');
const fileUploadArea = document.getElementById('file-upload-area');
const fileUploadButton = document.getElementById('file-upload-button');
const uploadedFilesList = document.getElementById('uploaded-files-list');
const uploadedFilesSection = document.getElementById('uploaded-files-section');

// File upload state - stores uploaded file data with base64 data URLs
let uploadedFilesData = [];

// thank you
const headerContainer = document.getElementById('header-container');
const buttonGroup = document.getElementById('button-group');
const thankContainerID = document.getElementById('thank-containerID');
const formContentID = document.getElementById('form-content');


// Error elements
const nameError = document.getElementById('name-error');
const emailError = document.getElementById('email-error');
const countryError = document.getElementById('country-error');

// Review elements
const reviewName = document.getElementById('review-name');
const reviewEmail = document.getElementById('review-email');
const reviewCountry = document.getElementById('review-country');
const reviewSelectedSneaker = document.getElementById('review-selected-sneaker');
const reviewSneakerType = document.getElementById('review-sneaker-type');
const reviewSneakerCategory = document.getElementById('review-sneaker-category');
const reviewSneakerBrand = document.getElementById('review-sneaker-brand');
const reviewSneakerSilhouette = document.getElementById('review-sneaker-silhouette');
const reviewSneakerImage = document.getElementById('review-sneaker-image');
const sneakerImageThanks = document.getElementById('sneaker-image-thank');
const reviewSneakerImagePlaceholder = document.getElementById('review-sneaker-image-placeholder');
const reviewSneakerImageContainer = document.getElementById('review-sneaker-image-container');
const reviewColor = document.getElementById('review-color');
const reviewSize = document.getElementById('review-size');
const reviewBudget = document.getElementById('review-budget');
const reviewTheme = document.getElementById('review-theme');
const subCategory = document.getElementById('review-sub-category');
const reviewAdditionalText = document.getElementById('review-additional-text');
const reviewAttachments = document.getElementById('review-attachments');
const reviewAttachmentsField = document.getElementById('review-attachments-field');
const sellerNameElement = document.getElementById('seller-name');
const creatorNameMobile = document.getElementById('creator-name-mobile');
const creatorNameDesktopElements = document.querySelectorAll('#creator-name-desktop');
const creatorImageMobile = document.getElementById('creator-image-mobile');
const creatorImageDesktopElements = document.querySelectorAll('#creator-image-desktop');
const creatorInitialsMobile = document.getElementById('creator-initials-mobile');
const creatorInitialsDesktopElements = document.querySelectorAll('#creator-initials-desktop');

let briefFormCollectionLookupById = {};
let briefFormCollectionLookupByHandle = {};
let selectedVendorName = deriveVendorNameFromDom();

// Theme and Subtheme mapping based on metafield definitions
const themeSubthemeMap = {
  "Sport": [
    "American Football", "Athletics", "Baseball", "Basketball", "Cricket", "Cycling", 
    "Darts", "Football", "Golf", "Hockey", "Motorsports", "Rugby", "Running", 
    "Skate Boarding", "Tennis", "Training / Gym"
  ],
  "Designer & Luxury": [
    "Bape", "Chanel", "Dior", "Fendi", "Gucci", "Louis Vuitton", "Off-White"
  ],
  "Art & Design": [
    "Abstract", "Architecture", "Classical", "Cubism", "Drip & Splatter", "Graffiti", 
    "Pop Art", "Realism", "Street Art"
  ],
  "Anime & Manga": [
    "Attack On Titan", "Chainsaw Man", "Disney", "Dragon Ball", "Jujutsu Kaisen", 
    "Manga", "Naruto", "One Piece", "Pokemon", "The Simpsons"
  ],
  "Cartoon & Comics": [
    "Batman", "DC Comics", "Looney Tunes", "Marvel", "Mickey Mouse", "Pokemon", 
    "Spiderman", "Superhero", "Superman", "The Simpsons"
  ],
  "Gaming": [
    "Call of Duty", "E Sports Teams", "Fortnite", "Grand Theft Auto", "Halo", 
    "Kelda", "Minecraft", "Nintendo", "Playstation", "Roblox", "Super Mario", "Xbox"
  ],
  "Music": [
    "Classical", "Country", "EDM", "K Pop", "Pop", "R&B / Soul", "Rap / Hip Hop", 
    "Reggae", "Rock"
  ],
  "Movies & TV Shows": [
    "Action", "Breaking Bad", "Childrens", "Comedy", "Cult Classics", "Disney", 
    "Fantasy", "Game Of Thrones", "Horror", "Pixar", "Science Fiction", "Star Wars", 
    "Stranger Things", "Wizarding World"
  ],
  "Nature & Animals": [
    "Animal prints", "Big Cats", "Birds & Winged", "Butterflies", "Floral & Botanical", 
    "Jungle & Safari", "Landscapes & Vistas", "Mythical & Fantasy", "Ocean & Marine", "Pets"
  ],
  "Culture & Heritage": [
    "Day of the Dead", "Dragons", "Flags", "Japanese Wave", "Koi"
  ],
  "Tattoo": [
    "Tattoo Style", "Tattooed Sneakers"
  ],
  "Minimalist": [
    "Camouflage", "Distressed", "Dyed", "Faded"
  ],
  "Food & Beverage": [
    "Sweets", "Fruit", "Coffee & Tea", "Snacks & Kawaii Food", "Cereals", 
    "Soft Drinks", "Energy Drinks", "Crisps", "Chocolates"
  ],
  "Kids": [
    "Disney", "Lilo & Stitch", "Ninja Turtles", "Toy Story", "Finding Nemo", 
    "Peppa Pig", "Frozen", "Spiderman", "Mickey Mouse"
  ],
  "Gifting": [
    "Wedding", "Milestones", "Celebrations"
  ]
};

(function buildBriefFormCollectionLookup() {
    const dataElement = document.getElementById('brief-form-collections-data');
    if (!dataElement) return;
    
    try {
        const collectionsData = JSON.parse(dataElement.textContent);
        if (Array.isArray(collectionsData)) {
            collectionsData.forEach(collection => {
                if (!collection) return;
                
                if (collection.id) {
                    briefFormCollectionLookupById[String(collection.id)] = collection;
                }
                if (collection.handle) {
                    briefFormCollectionLookupByHandle[collection.handle.toLowerCase()] = collection;
                }
            });
        }
    } catch (error) {
        console.error('Failed to parse Brief Form collections data:', error);
    }
})();

// Initialize form
function init() {
    // Populate country dropdown
    populateCountries();

    // Load saved form data
    loadFormData();
    
    // Initialize conditional field visibility
    // Category field is always visible, initialize it with empty state
    updateCategoryOptions('');
    
    if (sneakerTypeSelect && sneakerTypeSelect.value) {
            updateCategoryOptions(sneakerTypeSelect.value);
            updateCategoryLabel(sneakerTypeSelect.value);
      if (sneakerCategorySelect && sneakerCategorySelect.value) {
        updateBrandOptions(sneakerCategorySelect.value);
        if (sneakerBrandSelect && sneakerBrandSelect.value) {
          updateSilhouetteOptions(sneakerBrandSelect.value);
        }
      }
    }
    
    // Initialize sub-theme visibility (this will also populate subthemes if a theme is already selected)
    handleSubthemeVisibility();
    
    // Initialize size field visibility based on gender
    if (genderSelect && genderSelect.value) {
      updateSizeOptions(genderSelect.value);
    } else {
      updateSizeOptions('');
    }

    // Set up event listeners
    setupEventListeners();

    // Initialize step display
    updateStepDisplay();

    // Get initial step from URL
    const urlParams = new URLSearchParams(window.location.search);
    const stepParam = urlParams.get('step');
    if (stepParam) {
        const step = parseInt(stepParam);
        if (step >= 1 && step <= TOTAL_STEPS) {
            currentStep = step;
            updateStepDisplay();
        }
    }
    
    applyCreatorFromUrl();
}

function applyCreatorFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const creatorParam = urlParams.get('creator');
    if (!creatorParam) return;

    const collection = findCollectionByIdentifier(creatorParam);

    if (!collection) return;

    updateCreatorDisplay(collection);
}

function findCollectionByIdentifier(identifier) {
    if (!identifier) return null;
    
    const trimmed = identifier.trim();
    if (briefFormCollectionLookupById[trimmed]) {
        return briefFormCollectionLookupById[trimmed];
    }
    
    const numericOnly = trimmed.replace(/[^\d]/g, '');
    if (numericOnly && briefFormCollectionLookupById[numericOnly]) {
        return briefFormCollectionLookupById[numericOnly];
    }
    
    const lowerHandle = trimmed.toLowerCase();
    if (briefFormCollectionLookupByHandle[lowerHandle]) {
        return briefFormCollectionLookupByHandle[lowerHandle];
    }
    
    return null;
}

function updateCreatorDisplay(collection) {
    if (!collection) return;

    const name = collection.title;
    const imageUrl = collection.image;
    const imageAlt = collection.imageAlt;
    const displayName = name && name.trim() ? name.trim() : 'Creator Name';
    const hasImage = imageUrl && imageUrl.trim() !== '';
    const altText = imageAlt && imageAlt.trim() ? imageAlt.trim() : displayName;
    const profile_pic = collection.profile_picture;
    
    selectedVendorName = displayName;
    if (sellerNameElement) {
        sellerNameElement.textContent = displayName;
    }
    
    if (creatorNameMobile) {
        creatorNameMobile.textContent = displayName;
    }
    creatorNameDesktopElements.forEach(el => {
        el.textContent = displayName;
    });
    if (sneakerTypeSelect) {
      
    }
    
    if (hasImage || profile_pic) {
        if (creatorImageMobile) {
            creatorImageMobile.src = imageUrl ? imageUrl : profile_pic;
            creatorImageMobile.alt = altText;
            creatorImageMobile.style.display = '';
        }
        creatorImageDesktopElements.forEach(el => {
            el.src = imageUrl ? imageUrl : profile_pic;
            el.alt = altText;
            el.style.display = '';
        });
        if (creatorInitialsMobile) {
            creatorInitialsMobile.style.display = 'none';
        }
        creatorInitialsDesktopElements.forEach(el => {
            el.style.display = 'none';
        });
    } else {
        const initials = getInitialsFromName(displayName);
        if (creatorInitialsMobile) {
            creatorInitialsMobile.textContent = initials;
            creatorInitialsMobile.style.display = '';
        }
        creatorInitialsDesktopElements.forEach(el => {
            el.textContent = initials;
            el.style.display = '';
        });
        if (creatorImageMobile) {
            creatorImageMobile.removeAttribute('src');
            creatorImageMobile.style.display = 'none';
        }
        creatorImageDesktopElements.forEach(el => {
            el.removeAttribute('src');
            el.style.display = 'none';
        });
    }
    applyCollectionMetadataToSneakerFields(collection);
}

function applyCollectionMetadataToSneakerFields(collection) {
    if (!collection) return;

    const typeOptions = normalizeCollectionMetadataOptions(collection.customType);
    const brandOptions = normalizeCollectionMetadataOptions(collection.customBrand);
    const silhouetteOptions = normalizeCollectionMetadataOptions(collection.customSilhouette);

    if (typeOptions.length > 0) {
        updateSelectOptionsFromMetadata(sneakerTypeSelect, typeOptions, sneakerTypePlaceholder);
    }
    if (brandOptions.length > 0) {
        updateSelectOptionsFromMetadata(sneakerBrandSelect, brandOptions, sneakerBrandPlaceholder);
    }
    if (silhouetteOptions.length > 0) {
        updateSelectOptionsFromMetadata(sneakerSilhouetteSelect, silhouetteOptions, sneakerSilhouettePlaceholder);
    }
}

function updateSelectOptionsFromMetadata(selectElement, options, placeholderText) {
    if (!selectElement || !Array.isArray(options) || options.length === 0) {
        return;
    }

    const fragment = document.createDocumentFragment();
    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholderText || 'Select an option';
    fragment.appendChild(placeholderOption);

    options.forEach(option => {
        const opt = document.createElement('option');
        opt.value = option.value;
        opt.textContent = option.label;
        fragment.appendChild(opt);
    });

    selectElement.innerHTML = '';
    selectElement.appendChild(fragment);
    selectElement.value = '';
    selectElement.dispatchEvent(new Event('change', { bubbles: true }));
}

function normalizeCollectionMetadataOptions(raw) {
    if (!raw) return [];

    if (Array.isArray(raw)) {
        return raw.map(entry => normalizeMetadataOptionEntry(entry)).filter(Boolean);
    }

    if (typeof raw === 'object') {
        if (Array.isArray(raw.options)) {
            return raw.options.map(entry => normalizeMetadataOptionEntry(entry)).filter(Boolean);
        }
        if (Array.isArray(raw.value)) {
            return raw.value.map(entry => normalizeMetadataOptionEntry(entry)).filter(Boolean);
        }
        if (typeof raw.value === 'string') {
            return normalizeCollectionMetadataOptions(raw.value);
        }
    }

    if (typeof raw === 'string') {
        const entries = raw
            .split(/\r?\n/)
            .map(line => line.trim())
            .filter(Boolean);
        return entries.map(entry => normalizeMetadataOptionEntry(entry)).filter(Boolean);
    }

    return [];
}

function normalizeMetadataOptionEntry(entry) {
    if (!entry) return null;

    if (typeof entry === 'object') {
        const value = entry.value || entry.handle || entry.title || '';
        const label = entry.label || entry.title || value;
        const normalizedValue = typeof value === 'string' ? value.trim() : '';
        if (!normalizedValue) return null;
        return {
            value: normalizedValue,
            label: typeof label === 'string' && label.trim() ? label.trim() : normalizedValue
        };
    }

    if (typeof entry !== 'string') return null;

    const normalized = entry.trim();
    if (!normalized) return null;

    const [valuePart, labelPart] = normalized.split('|');
    const value = valuePart ? valuePart.trim() : '';
    const label = labelPart ? labelPart.trim() : value;

    if (!value) return null;

    return {
        value,
        label: label || value
    };
}

function getSelectPlaceholderText(selectElement) {
    if (!selectElement) return '';
    const placeholderOption = selectElement.querySelector('option[value=""]') || selectElement.options[0];
    return placeholderOption ? placeholderOption.textContent.trim() : '';
}

function getInitialsFromName(name) {
    if (!name || !name.trim()) {
        return 'CN';
    }
    
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
    }
    
    const firstInitial = parts[0] ? parts[0][0] : '';
    const lastInitial = parts[parts.length - 1] ? parts[parts.length - 1][0] : '';
    return (firstInitial + lastInitial).toUpperCase();
}

function deriveVendorNameFromDom() {
    if (sellerNameElement && sellerNameElement.textContent && sellerNameElement.textContent.trim()) {
        return sellerNameElement.textContent.trim();
    }
    if (creatorNameDesktopElements.length > 0 && creatorNameDesktopElements[0].textContent && creatorNameDesktopElements[0].textContent.trim()) {
        return creatorNameDesktopElements[0].textContent.trim();
    }
    if (creatorNameMobile && creatorNameMobile.textContent && creatorNameMobile.textContent.trim()) {
        return creatorNameMobile.textContent.trim();
    }
    return 'Creator Name';
}

function getVendorName() {
    const candidate = selectedVendorName && selectedVendorName.trim() ? selectedVendorName.trim() : '';
    if (candidate) {
        return candidate;
    }
    const derived = deriveVendorNameFromDom();
    return derived && derived.trim() ? derived.trim() : 'Creator Name';
}

function normalizeCustomerId(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const numeric = parseInt(value, 10);
    const isNumericNaN = typeof Number.isNaN === 'function' ? Number.isNaN(numeric) : isNaN(numeric);
    if (isNumericNaN) {
        return null;
    }
    return numeric > 0 ? numeric : null;
}

function getCustomerIdFromGlobals() {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) {
            const analyticsId = normalizeCustomerId(window.ShopifyAnalytics.meta.page.customerId);
            if (analyticsId) return analyticsId;
        }

        if (window.meta && window.meta.page && window.meta.page.customerId) {
            const metaId = normalizeCustomerId(window.meta.page.customerId);
            if (metaId) return metaId;
        }

        if (window.__st && window.__st.cid) {
            const storefrontId = normalizeCustomerId(window.__st.cid);
            if (storefrontId) return storefrontId;
        }
    } catch (error) {
        console.warn('Unable to read customer id from Shopify globals', error);
    }

    return null;
}

function resolveCustomerId() {
    const primary = normalizeCustomerId(LOGGED_IN_CUSTOMER_ID);
    if (primary) {
        return primary;
    }
    return getCustomerIdFromGlobals();
}

// Get flag emoji from country code
function getFlagEmoji(countryCode) {
    // Convert country code to flag emoji
    // Country codes are 2 letters, convert to flag emoji using Unicode regional indicator symbols
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
}

// Update country flag display (not needed - flag is in option text)
function updateCountryFlag() {
    // Flag is already in the option text, no need to update separately
}

// Populate country dropdown
function populateCountries() {
    if (!countrySelect) {
        return;
    }

    if (countrySelect.dataset.countriesAppended === 'true') {
        updateCountryFlag();
        return;
    }

    const existingOptionValues = new Set();
    Array.from(countrySelect.options).forEach(option => {
        const value = option.value && option.value.trim();
        if (value) {
            existingOptionValues.add(value.toLowerCase());
        }
    });

    const hasPriorityCountries = existingOptionValues.size > 0;

    const sortedCountries = Object.entries(COUNTRIES_BY_CODE)
        .filter(([code]) => !existingOptionValues.has(code.toLowerCase()))
        .sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));

    if (sortedCountries.length && hasPriorityCountries && !countrySelect.querySelector('.country-divider')) {
        const dividerOption = document.createElement('option');
        dividerOption.disabled = true;
        dividerOption.value = '';
        dividerOption.className = 'country-divider';
        dividerOption.setAttribute('aria-hidden', 'true');
        dividerOption.textContent = '------------------------------------------------------------';
        countrySelect.appendChild(dividerOption);
    }

    sortedCountries.forEach(([code, name]) => {
        const option = document.createElement('option');
        option.value = code;
        option.dataset.countrySection = 'global';
        const flagEmoji = getFlagEmoji(code);
        option.textContent = `${flagEmoji} ${name}`;
        countrySelect.appendChild(option);
    });

    countrySelect.dataset.countriesAppended = 'true';
    updateCountryFlag();
}

// Setup event listeners
// Mapping structure for Type → Category → Brand → Silhouette
// Based on metadata: cat--ztntfp (Shoe type) → cat-S-970t8r/cat-L-nyp1nh (Category) → cat-S-1ftyj6z/cat-SA-*/cat-SB-*/etc (Brand) → cat-SN-*/cat-SP-*/etc (Silhouette)
// For Sneakers, show all brands directly in the category field
const sneakersBrands = ['Nike','Jordan','CANVVS','Converse','Adidas','Puma','Vans','Yeezy','New Balance','Reebok','Under Armour','Alexander McQueen','All Birds','Asics','Axel Arigato','Balenciaga','Birkenstock','Burberry','DC','Diadora','Fila','Golden Goose','Gucci','Hugo Boss','Kickers','Loci','Louis Vuitton','Mache Runner','Notwoways','Off White','On Running','Prada','Salomon','Saucony','Sketchers','Superga','Veja','Other'];

// Gender → Size mapping based on metadata
// Men's Sizes In Stock: ["6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5","14","14.5","15","15.5","16"]
// Women's Sizes In Stock: ["4","4.5","5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12"]
// Children's Sizes In Stock: ["1","1.5","2","2.5","3","3.5","4","4.5","5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5"]
const genderSizeMapping = {
  'Men': ['6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13', '13.5', '14', '14.5', '15', '15.5', '16'],
  'Women': ['4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12'],
  'Children': ['1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13', '13.5']
};

const genderKeyMap = {
  men: 'Men',
  male: 'Men',
  m: 'Men',

  women: 'Women',
  female: 'Women',
  f: 'Women',

  child: 'Children',
  children: 'Children',
  kid: 'Children',
  kids: 'Children'
};

function updateSizeOptions(rawGender) {
  if (!sizeSelect || !sizeField) return;

  sizeSelect.innerHTML = '';

  const placeholderOption = document.createElement('option');
  placeholderOption.value = '';
  placeholderOption.textContent = 'Select size';
  sizeSelect.appendChild(placeholderOption);

  if (!rawGender) {
    sizeSelect.removeAttribute('required');
    return;
  }

  const normalized = rawGender.trim().toLowerCase();
  const key = genderKeyMap[normalized];

  if (!key || !genderSizeMapping[key]) {
    sizeSelect.removeAttribute('required');
    return;
  }

  const sizes = genderSizeMapping[key];
  sizes.forEach(size => {
        const option = document.createElement('option');
        option.value = size;
        // Show size with unit (US) in the visible label, but keep the raw value for form value
        const label = (typeof size === 'string' ? size : String(size));
        option.textContent = label.toLowerCase().includes('us') ? label : `${label} US`;
        sizeSelect.appendChild(option);
  });

  sizeSelect.value = '';
}

// Update the visible label for the category field depending on selected type
function updateCategoryLabel(type) {
    try {
        const isDirectBrand = type && typeCategoryMapping[type] && typeCategoryMapping[type].isDirectBrand;
        const label = isDirectBrand ? (brandLabelText || 'Brand') : (initialCategoryLabelText || 'Category');
        if (sneakerCategoryLabelEl) sneakerCategoryLabelEl.textContent = label;

        // Also update the placeholder text inside the category select so the first option
        // matches the visible label (e.g. when label becomes 'Brand' the placeholder should be 'Select Brand')
        try {
            if (sneakerCategorySelect && sneakerCategorySelect.options && sneakerCategorySelect.options.length > 0) {
                const placeholderText = isDirectBrand ? (sneakerBrandPlaceholder || 'Select Brand') : (sneakerCategoryPlaceholder || 'Select Category');
                sneakerCategorySelect.options[0].textContent = placeholderText;
            }
        } catch (e) {
            // ignore placeholder update errors
        }
    } catch (e) {
        // ignore
    }
}

const typeCategoryMapping = {
  'Sneakers': {
    categories: sneakersBrands, // For Sneakers, show all brands directl y in category field
    categoryField: 'cat-S-1ftyj6z',
    isDirectBrand: true // Flag to indicate category IS the brand for Sneakers
  },
  'Sports Shoes': {
    categories: ['Athletics', 'Baseball', 'Basketball', 'Cricket', 'Cycling', 'Football', 'Golf', 'Hockey', 'Ice Hockey', 'Lacrosse', 'Rugby', 'Soccer', 'Tennis', 'Volleyball'],
    categoryField: 'cat-S-970t8r'
  },
  'Lifestyle': {
    categories: ['Birkenstock', 'Crocs', 'Dr. Martin', 'Hunters', 'Timberland', 'UGG'],
    categoryField: 'cat-L-nyp1nh'
  }
};

// Category → Brand mapping based on metadata
// For Sneakers: When category is "Brand", show all brands from cat-S-1ftyj6z
// For Sports Shoes: Each category has its own brand list (cat-SA-*, cat-SB-*, etc.)
// For Lifestyle: Categories are the brands themselves (no separate brand field)
const categoryBrandMapping = {
  // Sports Shoes categories → Brands
  'Athletics': ['Adidas', 'Asics', 'Hoka', 'New Balance', 'Nike', 'NoBull', 'On Running', 'Reebok', 'Saucony', 'Sketchers', 'Solomon'], // cat-SA-1yb2nmr
  'Baseball': ['Adidas', 'Jordon', 'Miizuno', 'Mizuno', 'New Balance', 'Nike', 'Under Armour'], // cat-SB-2mi6zl
  'Basketball': ['361º', 'AND 1', 'Adidas', 'Anta', 'Brandblack', 'Converse', 'Crossover Culture', 'Jordon', 'K8IROS', 'Li - Ning', 'New Balance', 'Nike', 'Puma', 'Serious Player Only', 'Under Armour', 'Way Of Wade 10'], // cat-SB-dk0sm4
  'Cricket': ['Addidas', 'Gray - Nicolls', 'Gunn Moore', 'Kookaburra', 'New Balance', 'Payntr', 'Puma'], // cat-SC-vp1k74
  'Cycling': ['Bont', 'DMT', 'Fizik', 'Mavic', 'Rapha', 'Scott\'s', 'Shimano', 'Sidi', 'Specialized', 'Triban', 'Udog', 'Van Rysel'], // cat-SC-1ojzavt
  'Football': ['Adidas', 'Diadora', 'Lotto', 'Mizuno', 'New Balance', 'Nike', 'Puma', 'Sketchers'], // cat-SF-135sda8
  'Golf': ['Adidas', 'Cole Haan', 'ECCO', 'FootJoy', 'G/FORE', 'J.Lineberg', 'New Balance', 'Nike', 'Payntr', 'Puma', 'Sketchers', 'Under Armour'], // cat-SG-1563w9u
  'Hockey': ['Adidas', 'Asics', 'Dita', 'Grays', 'Kookaburra', 'Mizuno', 'Osaka'], // cat-SH-1b786wh
  'Ice Hockey': ['Bauer', 'CCM', 'True Catalyst', 'True Hzrdus'], // cat-SI-z0x9g1
  'Lacrosse': ['Adidas', 'Jordon', 'Miizuno', 'Mizuno', 'New Balance', 'Nike', 'Under Armour'], // cat-SL-1l89kn9
  'Rugby': ['Adidas', 'Ascis', 'Hoka', 'New Balance', 'Nike', 'NoBull', 'On Running', 'Reebok', 'Saucony', 'Sketchers', 'Solomon'], // cat-SR-18kqgrl
  'Soccer': ['Adidas', 'Diadora', 'Lotto', 'Mizuno', 'New Balance', 'Nike', 'Puma', 'Sketchers'], // cat-SS-tambzl
  'Tennis': ['Asics', 'Fit Ville', 'K-Swiss', 'Nike', 'On Men\'s', 'On the Roger', 'Sorel', 'Wilson'], // cat-ST-l7w3bj
  'Volleyball': ['361º', 'Adidas', 'Asics', 'Mizuno'], // cat-SV-1n3k834
  // Lifestyle categories are brands themselves (no separate brand field needed)
  'Birkenstock': [],
  'Crocs': [],
  'Dr. Martin': [],
  'Hunters': [],
  'Timberland': [],
  'UGG': []
};

// Brand → Silhouette mapping based on metadata
// cat-SN-uvfz21 (Nike), cat-SP-1j96o6h (Puma), cat-SJ-qf0741 (Jordan), cat-SA-expmaw (Adidas), 
// cat-SC-1ika0xx (Converse), cat-SN-1beu26t (New Balance), cat-SR-14lfjr (Reebok), cat-SV-eyxwoj (Vans)
const brandSilhouetteMapping = {
  'Nike': ['EG AF1','Air Cortez', 'Air Force 1', 'Air Force 1 Mid', 'Air Huarache', 'Air Max', 'Air Max 90', 'Air Max 95', 'Air Max 97', 'Air Max Pulse', 'Air More Uptempo', 'Air Vapour Max', 'Blazer High', 'Blazer Low', 'Court Vision', 'Dunk High', 'Dunk Low', 'Free Run 2', 'Nikecraft Mars Yard', 'Pegasus', 'SB Dunk', 'Tailwind', 'Waffle'], // cat-SN-uvfz21
  'Puma': ['1000v3', '180 Tones', 'Axelion Refresh Running', 'CA Pro Classic', 'Cali', 'Caven Outline', 'Classic xxi', 'Club Trainer', 'Clyde', 'Clyde Core', 'Future Ride Camo Flagship', 'Heritage Basket', 'Morphic', 'Palermo', 'RS - X Efekt Gradient', 'RS-X', 'Relatable 2', 'Roma Classic Gum', 'Speedcat', 'Suede Classic', 'Suede Decades', 'Trinity'], // cat-SP-1j96o6h
  'Jordan': ['AJ 1 High', 'AJ 1 Low', 'AJ 1 Mid', 'AJ 11', 'AJ 12', 'AJ 13', 'AJ 14', 'AJ 15', 'AJ 16', 'AJ 17', 'AJ 18', 'AJ 19', 'AJ 2', 'AJ 3', 'AJ 4', 'AJ 5', 'AJ 6', 'AJ 7', 'AJ 8', 'Jumpman MVP'], // cat-SJ-qf0741
  'Adidas': ['Boost', 'Campus 00', 'Cloudforma Pure', 'Forest Hills', 'Form High', 'Forum Bold', 'Forum Bonega', 'Forum Low', 'Gazelle', 'Hyperturf Adventure', 'Italia', 'NDM_R1', 'Nizza Platform', 'OZWEEGO', 'Samba', 'Stan Smith', 'Supernova 2', 'Superstar', 'Swift Run'], // cat-SA-expmaw
  'Converse': ['All Star High Utility', 'All Star Leather', 'All Star Lift', 'All Star Lift Platform', 'All Star Ox', 'Chuck 70 High', 'Chuck 70 Low', 'Chuck Taylor All Star High', 'Chuck Taylor All Star Low', 'Cons Pro', 'Legacy CX', 'Motion CX', 'One Star', 'Pro Leather', 'Run Star Hike', 'Run Star Hike Platform', 'Run Star Legacy', 'Run Star Motion CX Platform', 'Star Player', 'Star Player 76', 'Weapon CX'], // cat-SC-1ika0xx
  'New Balance': ['1080', '2002', '327', '373', '480', '530', '550', '574', '608', '725', '860', '878', '880', '9060', '990', '991', '992', '996', '997', 'MR530'], // cat-SN-1beu26t
  'Reebok': ['Answer', 'Answer IV', 'Classic', 'Classic Leather', 'Club C 85 Vintage', 'Club C Double', 'Club C Revenge Vintage', 'Court Peak', 'Es22', 'Ex 0 Fit', 'Freestyle High', 'Glide Shoes', 'Kamikaze', 'Nano 9', 'Nano X3', 'Pump Omni Zone ii', 'Question', 'Royal Ultra SL', 'Workout', 'Workout Plus'], // cat-SR-14lfjr
  'Vans': ['Authentic', 'Brigata', 'Checkerboard Classic Slip On', 'Comfy Crush Old School', 'Comfycush Slip On', 'Era', 'Exclusive', 'Gumsole Old School', 'KNU Skool', 'Old School', 'Platform Old School', 'Primary Check Old School', 'SK8 - Hi', 'SK8 - Low', 'Sk8 Old Skool', 'Slip On', 'Staple Cruze Too Comfy Cush', 'Ultra Range Exo', 'Unisex'] // cat-SV-eyxwoj
};

// Sneaker name → Type, Category, Brand, Silhouette mapping
// This maps sneaker names to their complete selection data
const sneakerDataMapping = {
  'Air Force 1': { type: 'Sneakers', category: 'Nike', brand: 'Nike', silhouette: 'Air Force 1' },
  'Air Force 1 Mid': { type: 'Sneakers', category: 'Nike', brand: 'Nike', silhouette: 'Air Force 1 Mid' },
  'Jordan 1 Low': { type: 'Sneakers', category: 'Jordan', brand: 'Jordan', silhouette: 'AJ 1 Low' },
  'Jordan 1 High': { type: 'Sneakers', category: 'Jordan', brand: 'Jordan', silhouette: 'AJ 1 High' },
  'BL_NK CANVVS': { type: 'Sneakers', category: '', brand: '', silhouette: '' } // Custom/blank option
};

// Function to get sneaker data from name (with fallback parsing)
function getSneakerData(sneakerName) {
  if (!sneakerName) return null;
  
  // Check direct mapping first
  if (sneakerDataMapping[sneakerName]) {
    return sneakerDataMapping[sneakerName];
  }
  
  // Try to parse from name (e.g., "Nike Air Force 1" or "Jordan AJ 1")
  const nameLower = sneakerName.toLowerCase();
  
  // Check for Nike silhouettes
  for (const silhouette of brandSilhouetteMapping['Nike'] || []) {
    if (nameLower.includes(silhouette.toLowerCase())) {
      return { type: 'Sneakers', category: 'Nike', brand: 'Nike', silhouette: silhouette };
    }
  }
  
  // Check for Jordan silhouettes
  for (const silhouette of brandSilhouetteMapping['Jordan'] || []) {
    if (nameLower.includes(silhouette.toLowerCase()) || nameLower.includes('jordan')) {
      return { type: 'Sneakers', category: 'Jordan', brand: 'Jordan', silhouette: silhouette };
    }
  }
  
  // Check for other brands
  for (const [brand, silhouettes] of Object.entries(brandSilhouetteMapping)) {
    for (const silhouette of silhouettes) {
      if (nameLower.includes(silhouette.toLowerCase()) || nameLower.includes(brand.toLowerCase())) {
        return { type: 'Sneakers', category: brand, brand: brand, silhouette: silhouette };
      }
    }
  }
  
  return null;
}

// Function to populate fields from sneaker data
function populateFieldsFromSneaker(sneakerData) {
  if (!sneakerData) return;
  
  // Set type
  if (sneakerData.type && sneakerTypeSelect) {
    sneakerTypeSelect.value = sneakerData.type;
    updateCategoryOptions(sneakerData.type);
            // Ensure the visible label matches the populated type (Brand vs Category)
            updateCategoryLabel(sneakerData.type);
    
    // Set category (for Sneakers, category is the brand)
    if (sneakerData.category && sneakerCategorySelect) {
      // Wait a bit for category options to populate
                setTimeout(() => {
                sneakerCategorySelect.value = sneakerData.category;

                const isDirectBrand = sneakerData.type === 'Sneakers';
                if (isDirectBrand) {
                    // For Sneakers, category IS the brand, so set brand and show silhouette
                    if (sneakerBrandSelect) {
                        sneakerBrandSelect.value = sneakerData.category;
                    }
                    if (sneakerData.silhouette) {
                        updateSilhouetteOptions(sneakerData.category);
                        setTimeout(() => {
                            if (sneakerSilhouetteSelect && sneakerData.silhouette) {
                                sneakerSilhouetteSelect.value = sneakerData.silhouette;
                            }
                        }, 100);
                    }
                } else {
                    // For Sports Shoes and Lifestyle
                    updateBrandOptions(sneakerData.category);
                    setTimeout(() => {
                        if (sneakerData.brand && sneakerBrandSelect) {
                            sneakerBrandSelect.value = sneakerData.brand;
                            // Only auto-show silhouette if the sneaker type supports silhouettes (e.g., Sneakers)
                            if (sneakerData.type === 'Sneakers' && sneakerData.silhouette) {
                                updateSilhouetteOptions(sneakerData.brand);
                                setTimeout(() => {
                                    if (sneakerSilhouetteSelect && sneakerData.silhouette) {
                                        sneakerSilhouetteSelect.value = sneakerData.silhouette;
                                    }
                                }, 100);
                            }
                        }
                    }, 100);
                }

                // Dispatch a change so the same handlers run as when a user selects the category manually
                try {
                    sneakerCategorySelect.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (e) {}
            }, 100);
    }
  }
}

// Function to reset section 2 fields
function resetSection2Fields() {
  // Reset sneaker selection
  if (selectedSneakerInput) {
    selectedSneakerInput.value = '';
  }
  if (sneakerGrid) {
    sneakerGrid.querySelectorAll('.sneaker-image').forEach(img => img.classList.remove('selected'));
  }
  
  // Reset type
  if (sneakerTypeSelect) {
    sneakerTypeSelect.value = '';
    updateCategoryOptions('');
  }
  
  // Reset category (but keep it visible)
  if (sneakerCategorySelect) {
    sneakerCategorySelect.value = '';
    // Clear options and show only placeholder
    sneakerCategorySelect.innerHTML = '';
    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = sneakerCategoryPlaceholder;
    sneakerCategorySelect.appendChild(placeholderOption);
  }
  
  // Reset and hide brand
  if (sneakerBrandSelect) {
    sneakerBrandSelect.value = '';
  }
  if (sneakerBrandField) {
        sneakerBrandField.classList.add('hidden');
        // remove any gridColumn override when hiding
        try { sneakerBrandField.style.gridColumn = ''; } catch (e) {}
  }
  
  // Reset and hide silhouette
  if (sneakerSilhouetteSelect) {
    sneakerSilhouetteSelect.value = '';
  }
  if (sneakerSilhouetteField) {
    sneakerSilhouetteField.classList.add('hidden');
  }
}

// Function to update category options based on type
function updateCategoryOptions(type) {
  if (!sneakerCategorySelect || !sneakerCategoryField) return;
  
  // Clear existing options
  sneakerCategorySelect.innerHTML = '';
  
  // Add placeholder
  const placeholderOption = document.createElement('option');
  placeholderOption.value = '';
  placeholderOption.textContent = sneakerCategoryPlaceholder;
  sneakerCategorySelect.appendChild(placeholderOption);
  
  // Category field is always visible, but only populate if type is selected
  if (!type || !typeCategoryMapping[type]) {
    sneakerCategorySelect.removeAttribute('required');
    return;
  }
  
  // Add category options
  const categories = typeCategoryMapping[type].categories;
  const isDirectBrand = typeCategoryMapping[type].isDirectBrand; // Check if category IS the brand (for Sneakers)
  
  categories.forEach(category => {
    const option = document.createElement('option');
    option.value = category;
    option.textContent = category;
    sneakerCategorySelect.appendChild(option);
  });
  
  // Reset category selection
  sneakerCategorySelect.value = '';
  
  // For Sneakers, category IS the brand, so hide brand field and show silhouette when category is selected
  if (isDirectBrand) {
    if (sneakerBrandField) {
      sneakerBrandField.classList.add('hidden');
      sneakerBrandSelect.value = '';
      sneakerBrandSelect.removeAttribute('required');
    }
  } else {
    // For Sports Shoes and Lifestyle, hide brand and silhouette fields initially
    if (sneakerBrandField) {
      sneakerBrandField.classList.add('hidden');
      sneakerBrandSelect.value = '';
      sneakerBrandSelect.removeAttribute('required');
    }
  }
  
  // Hide silhouette field initially
  if (sneakerSilhouetteField) {
    sneakerSilhouetteField.classList.add('hidden');
    sneakerSilhouetteSelect.value = '';
    sneakerSilhouetteSelect.removeAttribute('required');
  }
}

// Function to update brand options based on category
function updateBrandOptions(category) {
  if (!sneakerBrandSelect || !sneakerBrandField) return;
  
  // Clear existing options
  sneakerBrandSelect.innerHTML = '';
  
  if (!category) {
    sneakerBrandField.classList.add('hidden');
    sneakerBrandSelect.removeAttribute('required');
    return;
  }
  
  // Check if category has brands in mapping
  const brands = categoryBrandMapping[category];
  
  // If no brands or empty array, hide brand field (category is the brand itself, e.g., Lifestyle categories)
  if (!brands || brands.length === 0) {
        sneakerBrandField.classList.add('hidden');
        try { sneakerBrandField.style.gridColumn = ''; } catch (e) {}
    sneakerBrandSelect.removeAttribute('required');
    // Set category as brand value for Lifestyle (category IS the brand)
    sneakerBrandSelect.value = category;
    // Trigger change event to save the value
    sneakerBrandSelect.dispatchEvent(new Event('change', { bubbles: true }));
    // For Lifestyle, hide silhouette field (no silhouettes for these brands)
    if (sneakerSilhouetteField) {
      sneakerSilhouetteField.classList.add('hidden');
      sneakerSilhouetteSelect.value = '';
      sneakerSilhouetteSelect.removeAttribute('required');
    }
    return;
  }
  
  // Show brand field
    sneakerBrandField.classList.remove('hidden');
    // Make the brand field span the full grid width like the silhouette field so widths match
    try {
        sneakerBrandField.style.gridColumn = '1 / -1';
    } catch (e) {}
  
  // Add placeholder
  const placeholderOption = document.createElement('option');
  placeholderOption.value = '';
  placeholderOption.textContent = sneakerBrandPlaceholder;
  sneakerBrandSelect.appendChild(placeholderOption);
  
  // Add brand options
  brands.forEach(brand => {
    const option = document.createElement('option');
    option.value = brand;
    option.textContent = brand;
    sneakerBrandSelect.appendChild(option);
  });
  
  // Reset brand selection
  sneakerBrandSelect.value = '';
  
  // Hide silhouette field
  if (sneakerSilhouetteField) {
    sneakerSilhouetteField.classList.add('hidden');
    sneakerSilhouetteSelect.value = '';
    sneakerSilhouetteSelect.removeAttribute('required');
  }
}

// Function to update silhouette options based on brand
function updateSilhouetteOptions(brand) {
  if (!sneakerSilhouetteSelect || !sneakerSilhouetteField) return;
  
  // Clear existing options
  sneakerSilhouetteSelect.innerHTML = '';
  
  if (!brand || !brandSilhouetteMapping[brand]) {
    sneakerSilhouetteField.classList.add('hidden');
    sneakerSilhouetteSelect.removeAttribute('required');
    return;
  }
  
  // Show silhouette field
  sneakerSilhouetteField.classList.remove('hidden');
  
  // Add placeholder
  const placeholderOption = document.createElement('option');
  placeholderOption.value = '';
  placeholderOption.textContent = sneakerSilhouettePlaceholder;
  sneakerSilhouetteSelect.appendChild(placeholderOption);
  
  // Add silhouette options
  const silhouettes = brandSilhouetteMapping[brand];
  silhouettes.forEach(silhouette => {
    const option = document.createElement('option');
    option.value = silhouette;
    option.textContent = silhouette;
    sneakerSilhouetteSelect.appendChild(option);
  });
  
  // Reset silhouette selection
  sneakerSilhouetteSelect.value = '';
}

function setupEventListeners() {
    // Navigation buttons
    backBtn.addEventListener('click', handleBack);
    nextBtn.addEventListener('click', handleNext);
    form.addEventListener('submit', handleSubmit);

    // Close buttons
    closeBtn.addEventListener('click', handleClose);
    closeBtnDesktop.addEventListener('click', handleClose);

    // Form field changes - save to session storage
    nameInput.addEventListener('input', saveFormData);
    emailInput.addEventListener('input', saveFormData);
    countrySelect.addEventListener('change', () => {
        updateCountryFlag();
        saveFormData();
    });

    // Step 2 fields - Sneaker card selection
    if (sneakerGrid) {
        const sneakerCards = sneakerGrid.querySelectorAll('.sneaker-card');
        sneakerCards.forEach(card => {
            card.addEventListener('click', function(e) {
                // Find the image element within the clicked card
                const imageElement = this.querySelector('.sneaker-image');
                if (imageElement) {
                    const sneakerName = this.getAttribute('data-sneaker-name') || '';
                    const isCurrentlySelected = imageElement.classList.contains('selected');
                    
                    // Toggle: if already selected, deselect and reset
                    if (isCurrentlySelected) {
                        // Deselect
                        imageElement.classList.remove('selected');
                        if (selectedSneakerInput) {
                            selectedSneakerInput.value = '';
                        }
                        // Reset all fields in section 2
                        resetSection2Fields();
                        saveFormData();
                        return;
                    }
                    
                    // Remove selected class from all images
                    sneakerGrid.querySelectorAll('.sneaker-image').forEach(img => img.classList.remove('selected'));
                    // Add selected class to clicked image
                    imageElement.classList.add('selected');
                    
                    // Update hidden input
                    if (selectedSneakerInput) {
                        selectedSneakerInput.value = sneakerName;
                    }
                    
                    // Auto-populate fields based on sneaker name
                    const sneakerData = getSneakerData(sneakerName);
                    if (sneakerData) {
                        populateFieldsFromSneaker(sneakerData);
                    }
                    
                    saveFormData();
                }
            });
        });
    }

    // Step 2 fields - Manual search
    if (sneakerTypeSelect) {
            sneakerTypeSelect.addEventListener('change', function() {
                const sneaker_category = document.getElementById('sneaker-category-field-container');
                const shoe_type_other = document.getElementById('shoe_type_other');
                if( this.value == "Other"){
                    sneaker_category.classList.add('hidden');
                    shoe_type_other.classList.remove('hidden');
                    sneakerSilhouetteField.classList.add('hidden');
                }else{
                    sneaker_category.classList.remove('hidden');
                    shoe_type_other.classList.add('hidden');
                    updateCategoryOptions(this.value);
                    updateCategoryLabel(this.value);
                }
                
                saveFormData();
            });
    }
        if (sneakerCategorySelect) {
            sneakerCategorySelect.addEventListener('change', function() {
                const selectedType = sneakerTypeSelect ? sneakerTypeSelect.value : '';
                const isDirectBrand = selectedType === 'Sneakers';

                if (isDirectBrand) {
                    // For Sneakers, category IS the brand, so show silhouette directly
                    const selectedBrand = this.value;
                    updateSilhouetteOptions(selectedBrand);
                    // Set brand value to category value for Sneakers
                    if (sneakerBrandSelect) {
                        sneakerBrandSelect.value = selectedBrand;
                    }
                } else {
                    // For Sports Shoes and Lifestyle, show brand field
                    updateBrandOptions(this.value);
                }
                // Always update the category label when category changes (keeps UI consistent)
                updateCategoryLabel(selectedType);
                saveFormData();
            });
        }
        if (sneakerBrandSelect) {
            sneakerBrandSelect.addEventListener('change', function() {
                // Only show silhouette when the selected Type requires silhouettes (e.g., Sneakers)
                const selectedType = sneakerTypeSelect ? sneakerTypeSelect.value : '';
                if (selectedType === 'Sneakers') {
                    updateSilhouetteOptions(this.value);
                } else {
                    // Ensure silhouette is hidden for non-Sneakers
                    if (sneakerSilhouetteField) {
                        sneakerSilhouetteField.classList.add('hidden');
                        sneakerSilhouetteSelect.value = '';
                        sneakerSilhouetteSelect.removeAttribute('required');
                    }
                }
                saveFormData();
            });
        }
    if (sneakerSilhouetteSelect) sneakerSilhouetteSelect.addEventListener('change', saveFormData);

    // Step 3 fields
    if (colorSelect) {
        colorSelect.addEventListener('change', function() {
            handleColorFieldChange();
            saveFormData();
        });
    }
    if (colorOtherInput) {
        colorOtherInput.addEventListener('input', saveFormData);
    }
    if (preferencesBudgetSelect) preferencesBudgetSelect.addEventListener('change', saveFormData);
    if (genderSelect) {
      genderSelect.addEventListener('change', function() {
        updateSizeOptions(this.value);
        saveFormData();
      });
    }
    if (sizeSelect) sizeSelect.addEventListener('change', saveFormData);
    if (themeSelect) {
        themeSelect.addEventListener('change', function() {
            handleSubthemeVisibility();
            saveFormData();
        });
    }
    if (subthemeSelect) subthemeSelect.addEventListener('change', saveFormData);

    // Step 4 fields
    if (additionalTextTextarea) additionalTextTextarea.addEventListener('input', saveFormData);
    
    // File upload handling
    if (fileUploadButton) {
        fileUploadButton.addEventListener('click', function(e) {
            e.preventDefault();
            if (fileUploadInput) {
                fileUploadInput.click();
            }
        });
    }
    
    if (fileUploadArea) {
        fileUploadArea.addEventListener('click', function(e) {
            if (e.target === fileUploadArea || e.target.classList.contains('file-upload-text')) {
                if (fileUploadInput) {
                    fileUploadInput.click();
                }
            }
        });
        
        // Drag and drop
        fileUploadArea.addEventListener('dragover', function(e) {
            e.preventDefault();
            fileUploadArea.classList.add('dragover');
        });
        
        fileUploadArea.addEventListener('dragleave', function(e) {
            e.preventDefault();
            fileUploadArea.classList.remove('dragover');
        });
        
        fileUploadArea.addEventListener('drop', function(e) {
            e.preventDefault();
            fileUploadArea.classList.remove('dragover');
            if (fileUploadInput && e.dataTransfer.files.length > 0) {
                const dt = new DataTransfer();
                // Add existing files
                if (fileUploadInput.files) {
                    Array.from(fileUploadInput.files).forEach(file => dt.items.add(file));
                }
                // Add new dropped files
                Array.from(e.dataTransfer.files).forEach(file => dt.items.add(file));
                fileUploadInput.files = dt.files;
                handleFileUpload();
            }
        });
    }
    
    if (fileUploadInput) {
        fileUploadInput.addEventListener('change', handleFileUpload);
    }

    // Real-time validation for all required fields
    const allRequiredFields = document.querySelectorAll('input[required], select[required], textarea[required]');
    allRequiredFields.forEach(field => {
        // Use 'change' for SELECT and FILE inputs, 'blur' for others
        const eventType = (field.tagName === 'SELECT' || field.type === 'file') ? 'change' : 'blur';
        field.addEventListener(eventType, function() {
            const errorElement = document.getElementById(`${this.id}-error`);
            
            // Handle file inputs differently
            let isEmpty = false;
            if (this.type === 'file') {
                isEmpty = !this.files || this.files.length === 0;
            } else {
                isEmpty = !this.value.trim();
            }

            if (isEmpty) {
                if (errorElement) {
                    const errorMsg = errorElement.getAttribute('data-error') || `${this.name} is required`;
                    errorElement.textContent = errorMsg;
                    updateLabelErrorState(this.id, true);
                }
            } else {
                // Special validation for email
                if (this.type === 'email' && !isValidEmail(this.value.trim())) {
                    if (errorElement) {
                        errorElement.textContent = 'Invalid email address';
                        updateLabelErrorState(this.id, true);
                    }
                } else if (errorElement) {
                    errorElement.textContent = '';
                    updateLabelErrorState(this.id, false);
                }
            }
        });
    });
}

// Handle color field transformation
function handleColorFieldChange() {
    if (!colorSelect || !colorOtherInput) return;
    
    const selectedValue = colorSelect.value.toLowerCase();
    
    if (selectedValue === 'other') {
        // Show input, hide select
        colorSelect.style.display = 'none';
        colorSelect.removeAttribute('required');
        colorOtherInput.style.display = 'block';
        if (colorSelect.hasAttribute('required')) {
            colorOtherInput.setAttribute('required', 'required');
        }
        colorOtherInput.focus();
    } else {
        // Show select, hide input
        colorSelect.style.display = 'block';
        colorOtherInput.style.display = 'none';
        colorOtherInput.removeAttribute('required');
        colorOtherInput.value = '';
        if (colorOtherInput.hasAttribute('required')) {
            colorSelect.setAttribute('required', 'required');
        }
    }
}

// Populate subtheme select based on selected theme
function populateSubthemeSelect(selectedTheme) {
    if (!subthemeSelect) return;
    
    // Get placeholder text from existing first option before clearing
    const existingPlaceholder = subthemeSelect.options.length > 0 && subthemeSelect.options[0].value === '' 
        ? subthemeSelect.options[0].textContent 
        : 'Select sub theme';
    
    // Clear existing options
    subthemeSelect.innerHTML = '';
    
    // Add placeholder option
    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = existingPlaceholder;
    subthemeSelect.appendChild(placeholderOption);
    
    // Get subthemes for selected theme
    // Try exact match first, then try case-insensitive match
    let subthemes = themeSubthemeMap[selectedTheme];
    if (!subthemes) {
        // Try case-insensitive lookup
        const themeKey = Object.keys(themeSubthemeMap).find(
            key => key.toLowerCase() === selectedTheme.toLowerCase()
        );
        if (themeKey) {
            subthemes = themeSubthemeMap[themeKey];
        }
    }
    
    // If we found subthemes from metafield mapping, populate them
    if (subthemes && Array.isArray(subthemes)) {
        subthemes.forEach(subtheme => {
            const option = document.createElement('option');
            option.value = subtheme;
            option.textContent = subtheme;
            subthemeSelect.appendChild(option);
        });
    }
    
    // Reset subtheme value
    subthemeSelect.value = '';
}

// Handle sub-theme field visibility
function handleSubthemeVisibility() {
    if (!themeSelect || !subthemeField) return;
    
    const selectedTheme = themeSelect.value.trim();
    const themeWrapper = themeSelect.closest('.theme-subtheme-wrapper');
    
    if (selectedTheme) {
        // Populate subtheme options based on selected theme
        populateSubthemeSelect(selectedTheme);
        
        // Show sub-theme field when theme is selected
        subthemeField.classList.remove('hidden');
        // Add class to enable two-column layout
        if (themeWrapper) {
            themeWrapper.classList.add('has-subtheme');
        }
        
        // Add required attribute if needed
        if (subthemeSelect && subthemeSelect.hasAttribute('data-required')) {
            subthemeSelect.setAttribute('required', 'required');
        }
    } else {
        // Hide sub-theme field when theme is cleared
        subthemeField.classList.add('hidden');
        // Remove class to return to single-column layout
        if (themeWrapper) {
            themeWrapper.classList.remove('has-subtheme');
        }
        if (subthemeSelect) {
            // Get placeholder text before clearing (if it exists)
            const placeholderText = subthemeSelect.options.length > 0 && subthemeSelect.options[0].value === ''
                ? subthemeSelect.options[0].textContent
                : 'Select sub theme';
            
            subthemeSelect.value = '';
            subthemeSelect.removeAttribute('required');
            subthemeSelect.innerHTML = '';
            
            // Add placeholder back
            const placeholderOption = document.createElement('option');
            placeholderOption.value = '';
            placeholderOption.textContent = placeholderText;
            subthemeSelect.appendChild(placeholderOption);
        }
    }
}

// Update step display
function updateStepDisplay() {
    // Hide all steps
    for (let i = 1; i <= TOTAL_STEPS; i++) {
        const stepElement = document.getElementById(`step-${i}`);
        if (stepElement) {
            stepElement.style.display = 'none';
        }
    }

    // Show current step
    const currentStepElement = document.getElementById(`step-${currentStep}`);
    if (currentStepElement) {
        currentStepElement.style.display = 'flex';
    }

    // Update step indicators
    updateStepIndicators();

    // Update navigation buttons
    updateNavigationButtons();

    // Update review step if on the last step (review step)
    if (currentStep === TOTAL_STEPS) {
        updateReviewStep();
    }
}

// Update step indicators
function updateStepIndicators() {
    document.querySelectorAll('.step-label').forEach((label, index) => {
        const stepNum = index + 1;
        const circle = label.querySelector('.step-circle');
        const text = label.querySelector('.step-text');

        if (stepNum <= currentStep) {
            circle.classList.add('active');
            text.classList.add('active');
        } else {
            circle.classList.remove('active');
            text.classList.remove('active');
        }
    });

  const mobileSteps = document.querySelectorAll('.mobile-step');
  mobileSteps.forEach((stepWrapper, index) => {
      const circle = stepWrapper.querySelector('.mobile-step-circle');
      const connector = stepWrapper.querySelector('.mobile-step-connector');
      if (!circle) return;

      const stepNum = index + 1;
      circle.classList.remove('active', 'completed');

      if (stepNum < currentStep) {
          circle.classList.add('completed');
      } else if (stepNum === currentStep) {
          circle.classList.add('active');
      }

      circle.textContent = stepNum;

      if (connector) {
          connector.classList.toggle('active', stepNum < currentStep);
      }
  });
}

// Update navigation buttons
function updateNavigationButtons() {
    backBtn.disabled = currentStep === 1;

    if (currentStep < TOTAL_STEPS) {
        nextBtn.style.display = 'flex';
        submitBtn.style.display = 'none';
    } else {
        nextBtn.style.display = 'none';
        submitBtn.style.display = 'flex';
    }
}

// Validate field
function validateField(fieldName) {
    let isValid = true;
    let errorMessage = '';

    switch (fieldName) {
        case 'name':
            const name = nameInput.value.trim();
            const nameRequired = nameInput.hasAttribute('required');
            if (nameRequired && !name) {
                isValid = false;
                // Get the error message from the span element's text content (set by Liquid)
                const errorSpan = document.getElementById('name-error');
                errorMessage = errorSpan ? errorSpan.getAttribute('data-error') || errorSpan.textContent || 'Name is required' : 'Name is required';
            }
            if (nameError) {
                nameError.textContent = errorMessage;
                updateLabelErrorState('name', !isValid);
            }
            break;

        case 'email':
            const email = emailInput.value.trim();
            const emailRequired = emailInput.hasAttribute('required');
            if (emailRequired && !email) {
                isValid = false;
                const errorSpan = document.getElementById('email-error');
                errorMessage = errorSpan ? errorSpan.getAttribute('data-error') || errorSpan.textContent || 'Email is required' : 'Email is required';
            } else if (email && !isValidEmail(email)) {
                isValid = false;
                errorMessage = 'Invalid email address';
            }
            if (emailError) {
                emailError.textContent = errorMessage;
                updateLabelErrorState('email', !isValid);
            }
            break;

        case 'country':
            const country = countrySelect.value;
            const countryRequired = countrySelect.hasAttribute('required');
            if (countryRequired && !country) {
                isValid = false;
                const errorSpan = document.getElementById('country-error');
                errorMessage = errorSpan ? errorSpan.getAttribute('data-error') || errorSpan.textContent || 'Country is required' : 'Country is required';
            }
            if (countryError) {
                countryError.textContent = errorMessage;
                updateLabelErrorState('country', !isValid);
            }
            break;
    }

    return isValid;
}

// Validate email format
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Update label error state based on error message
function updateLabelErrorState(fieldId, hasError) {
    const field = document.getElementById(fieldId);
    if (!field) return;
    
    const label = document.querySelector(`label[for="${fieldId}"]`);
    if (label) {
        if (hasError) {
            label.classList.add('has-error');
        } else {
            label.classList.remove('has-error');
        }
    }
}

// Validate all inputs in current step
function validateAllFieldsInStep(stepNumber) {
    const stepElement = document.getElementById(`step-${stepNumber}`);
    if (!stepElement) return true;

    let allValid = true;
    const inputs = stepElement.querySelectorAll('input[required], select[required], textarea[required]');

    inputs.forEach(input => {
        // Handle file inputs differently
        let isEmpty = false;
        if (input.type === 'file') {
            isEmpty = !input.files || input.files.length === 0;
        } else {
            isEmpty = !input.value.trim();
        }
        
        const errorElement = stepElement.querySelector(`#${input.id}-error`);

        if (isEmpty) {
            allValid = false;
            if (errorElement) {
                const errorMsg = errorElement.getAttribute('data-error') || `${input.name} is required`;
                errorElement.textContent = errorMsg;
                updateLabelErrorState(input.id, true);
            }
        } else {
            // Special validation for email
            if (input.type === 'email' && !isValidEmail(input.value.trim())) {
                allValid = false;
                if (errorElement) {
                    errorElement.textContent = 'Invalid email address';
                    updateLabelErrorState(input.id, true);
                }
            } else if (errorElement) {
                errorElement.textContent = '';
                updateLabelErrorState(input.id, false);
            }
        }
    });

    return allValid;
}

// Validate current step
function validateStep(step) {
    // Use the new generic validation for all steps
    return validateAllFieldsInStep(step);
}

// Validate previous steps
function validatePreviousSteps() {
    for (let i = 1; i < currentStep; i++) {
        if (!isStepComplete(i)) {
            return false;
        }
    }
    return true;
}

// Check if step is complete
function isStepComplete(step) {
    const stepElement = document.getElementById(`step-${step}`);
    if (!stepElement) return true;

    const requiredInputs = stepElement.querySelectorAll('input[required], select[required], textarea[required]');

    for (let input of requiredInputs) {
        const value = input.value.trim();
        if (!value) return false;

        // Special validation for email
        if (input.type === 'email' && !isValidEmail(value)) {
            return false;
        }
    }

    return true;
}

// Handle next button
async function handleNext(e) {
    e.preventDefault();

    // Validate current step
    if (!validateStep(currentStep)) {
        showNotification('Please complete all required fields', 'error');
        return;
    }

    // Save form data
    saveFormData();

    // Move to next step
    if (currentStep < TOTAL_STEPS) {
        currentStep++;
        updateStepDisplay();
        updateURL();
    }
    
    
}

// Handle back button
function handleBack(e) {
    e.preventDefault();

    if (currentStep > 1) {
        currentStep--;
        updateStepDisplay();
        updateURL();
    }
}

// Handle form submit
async function handleSubmit(e) {
    e.preventDefault();

    // Validate all steps
    if (!validateStep(currentStep)) {
        showNotification('Please complete all required fields', 'error');
        return;
    }

    // Validate previous steps
    if (!validatePreviousSteps()) {
        showNotification('Please complete previous steps first', 'error');
        return;
    }

    // Get form data
    let formData, payload;
    try {
        formData = getFormData();
        console.log('Form data retrieved');
        payload = buildSubmissionPayload(formData);
        console.log('Payload built successfully');
    } catch (buildError) {
        console.error('Error building payload:', buildError);
        showNotification('Error preparing form data: ' + buildError.message, 'error');
        return;
    }

    // Disable submit button to prevent double submits
    try {
        if (submitBtn) {
            submitBtn.disabled = true;
            const submittingText = submitBtn.getAttribute('data-submitting-text') || 'Sending...';
            submitBtn.textContent = submittingText;
            console.log('Submit button disabled, text changed to:', submittingText);
        } else {
            console.warn('Submit button not found');
        }
    } catch (btnError) {
        console.error('Error updating submit button:', btnError);
    }

    try {
        const url = 'https://creators.canvvs.com/api3/custom/canvvs/send-brief';
        console.log('About to send request to:', url);
        console.log('Payload preview:', {
            customerId: payload.customerId,
            vendor: payload.vendor,
            fieldsCount: payload.fields.length
        });

        console.log('Executing fetch...');
        
        // Create abort controller for timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            console.warn('Request timeout after 30 seconds');
            controller.abort();
        }, 30000); // 30 second timeout
        
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(payload),
            signal: controller.signal
        });

        clearTimeout(timeoutId);
        console.log('Fetch completed, status:', response.status, response.statusText);
        
        const contentType = response.headers.get('content-type') || '';
        let data;

        if (contentType.includes('application/json')) {
            try {
            data = await response.json();
            } catch (e) {
            // JSON parse failed, keep data as null
            data = null;
            }
        } else {
            try {
            data = await response.text();
            } catch (e) {
            data = null;
            }
        }

        if (!response.ok) {
            const message =
            (data && typeof data === 'object' && data.message) ? data.message :
            (typeof data === 'string' && data.trim()) ? data :
            `Submission failed (HTTP ${response.status})`;

            showNotification(message, 'error');
            console.error('Submission error:', response.status, data);
            return;
        }

        // Success
        console.log('Form submitted successfully');
        console.log('Response data:', data);
        console.log('Payload sent:', payload);
        // showNotification('Request sent successfully! We will get back to you shortly.', 'success');

       // Optional: redirect after success
        clearFormData();
        // 🔒 Prevent duplicates
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitted';

        document.querySelectorAll('.form-step').forEach(step => {
            step.style.display = 'none';
        });
        formContentID.style.display = 'none';
        thankContainerID.style.display = 'block';
        headerContainer.style.display = 'none';
        buttonGroup.style.display = 'none';
         setTimeout(() => {
            window.location.href = '/';
        }, 5000);

        return;

    } catch (err) {
        console.error('Network or unexpected error when submitting form:', err);
        console.error('Error name:', err.name);
        console.error('Error message:', err.message);
        
        if (err.name === 'AbortError') {
            showNotification('Request timed out. The server is taking too long to respond. Please try again.', 'error');
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-submit-text') || 'Submit';
            return;
        }
        
        // For now, show success even on error (as per original code - "to remove soon")
        // showNotification('Network error: failed to send request. Please try again later.', 'error');
        // showNotification(
        //     'Your request was sent successfully. If you do not receive a confirmation shortly, please contact support.',
        //     'success'
        // );
        // to remove soon
        clearFormData();
        // 🔒 Prevent duplicates
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitted';

        document.querySelectorAll('.form-step').forEach(step => {
            step.style.display = 'none';
        });
        formContentID.style.display = 'none';
        thankContainerID.style.display = 'block';
        headerContainer.style.display = 'none';
        buttonGroup.style.display = 'none';
         setTimeout(() => {
            window.location.href = '/';
        }, 5000);

        return;

    } finally {
         // Only re-enable if NOT locked as submitted to remove soon
        if (!submitBtn.disabled || submitBtn.textContent !== 'Submitted') {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-submit-text') || 'Submit';
        }
        // Re-enable submit button
        // submitBtn.disabled = false;
        // const submitText = submitBtn.getAttribute('data-submit-text') || 'Submit';
        // submitBtn.textContent = submitText;
    }
}

// Handle close button
function handleClose() {
    const formData = getFormData();
    const hasData = Object.values(formData).some(value => value && value !== '');

    if (hasData) {
        if (confirm('You have unsaved changes. Are you sure you want to leave?')) {
            // Go back to the previous page in browser history
            window.history.back();
        }
    } else {
        // Go back to the previous page in browser history
        window.history.back();
    }
}

// Convert file to base64 data URL
function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
}

// Compress image to target file size (around 100KB)
function compressImage(file, targetSizeKB = 100, maxWidth = 1920) {
    return new Promise((resolve, reject) => {
        // If not an image, just convert to base64
        if (!file.type.startsWith('image/')) {
            return fileToBase64(file).then(resolve).catch(reject);
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                // Calculate dimensions to maintain aspect ratio
                let width = img.width;
                let height = img.height;
                
                if (width > maxWidth) {
                    height = (height * maxWidth) / width;
                    width = maxWidth;
                }
                
                // Create canvas for compression
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                
                // Start with quality 0.9 and reduce until size is acceptable
                let quality = 0.9;
                let compressed = canvas.toDataURL('image/jpeg', quality);
                
                // Calculate current size in KB
                let currentSizeKB = Math.round((compressed.length * 3) / 4 / 1024);
                
                console.log(`Original: ${(file.size / 1024).toFixed(2)}KB, Compressed: ${currentSizeKB}KB at quality ${quality}`);
                
                // If image is too large, reduce quality iteratively
                while (currentSizeKB > targetSizeKB && quality > 0.1) {
                    quality -= 0.1;
                    compressed = canvas.toDataURL('image/jpeg', quality);
                    currentSizeKB = Math.round((compressed.length * 3) / 4 / 1024);
                }
                
                console.log(`Final: ${currentSizeKB}KB at quality ${quality.toFixed(2)}`);
                resolve(compressed);
            };
            img.onerror = reject;
            img.src = e.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

// Handle file upload - converts to base64 and displays preview
async function handleFileUpload() {
    if (!fileUploadInput || !uploadedFilesList || !uploadedFilesSection) return;
    
    const files = Array.from(fileUploadInput.files);
    if (files.length === 0) return;
    
    // Show uploaded files section
    uploadedFilesSection.style.display = 'block';
    
    // Process each new file
    for (const file of files) {
        // Check if file is already processed (by name)
        const existingIndex = uploadedFilesData.findIndex(f => f.name === file.name);
        if (existingIndex !== -1) continue; // Skip already processed files
        
        const isImage = file.type.startsWith('image/');
        const tempId = `file-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        
        // Create file item with loading state
        const fileItem = document.createElement('div');
        fileItem.className = 'uploaded-file-item';
        fileItem.id = tempId;
        
        fileItem.innerHTML = `
            ${isImage ? `<div class="uploaded-file-preview-wrapper">
                <div class="upload-loading-placeholder">
                    <div class="upload-spinner"></div>
                </div>
            </div>` : `<div class="uploaded-file-icon uploading">📄</div>`}
            <span class="uploaded-file-name" style="display:none;">${file.name}</span>
            <span class="upload-status">Processing...</span>
        `;
        uploadedFilesList.appendChild(fileItem);
        
        try {
            // Compress and convert image to base64 (target ~100KB)
            const base64DataUrl = await compressImage(file, 100, 1920);
            
            // Calculate compressed size
            const compressedSizeKB = Math.round((base64DataUrl.length * 3) / 4 / 1024);
            
            // Store file data with compressed base64 URL
            uploadedFilesData.push({
                name: file.name,
                url: base64DataUrl,
                type: file.type,
                size: file.size,
                compressedSize: compressedSizeKB * 1024, // Store compressed size in bytes
                tempId: tempId
            });
            
            // Update the file item with preview and remove link
            const fileIndex = uploadedFilesData.length - 1;
            const originalSizeKB = (file.size / 1024).toFixed(0);
            const sizeInfo = isImage ? 
                `<span class="file-size-info">${originalSizeKB}KB → ${compressedSizeKB}KB</span>` : 
                `<span class="file-size-info">${originalSizeKB}KB</span>`;
            
            fileItem.innerHTML = `
                ${isImage ? `<img src="${base64DataUrl}" class="uploaded-file-preview" width="150"/>` : `<div class="uploaded-file-icon">📄</div>`}
                <div class="uploaded-file-details">
                    <span class="uploaded-file-name">${file.name}</span>
                    ${sizeInfo}
                </div>
                <a href="#" class="remove-file-link" data-file-index="${fileIndex}">Remove</a>
            `;
            
            // Add remove functionality
            const removeLink = fileItem.querySelector('.remove-file-link');
            removeLink.addEventListener('click', function(e) {
                e.preventDefault();
                removeUploadedFile(fileIndex);
            });
        } catch (error) {
            console.error('File processing error:', error);
            // Processing failed - show error state
            fileItem.innerHTML = `
                ${isImage ? `<div class="uploaded-file-preview-wrapper error">
                    <div class="upload-error-icon">⚠️</div>
                </div>` : `<div class="uploaded-file-icon error">📄</div>`}
                <span class="uploaded-file-name">${file.name}</span>
                <span class="upload-status error">Failed to process</span>
            `;
        }
    }
    
    // Hide section if no files processed successfully
    if (uploadedFilesData.length === 0) {
        uploadedFilesSection.style.display = 'none';
    }
    
    // Clear error state when files are added
    const fileUploadError = document.getElementById('file-upload-error');
    if (fileUploadError && uploadedFilesData.length > 0) {
        fileUploadError.textContent = '';
        updateLabelErrorState('file-upload', false);
    }
    
    saveFormData();
}

// Remove file from upload (legacy - kept for compatibility)
function removeFile(index) {
    if (!fileUploadInput) return;
    
    const dt = new DataTransfer();
    const files = Array.from(fileUploadInput.files);
    
    files.forEach((file, i) => {
        if (i !== index) {
            dt.items.add(file);
        }
    });
    
    fileUploadInput.files = dt.files;
    
    // Update the display
    if (fileUploadInput.files.length === 0) {
        if (uploadedFilesSection) uploadedFilesSection.style.display = 'none';
        
        // Check if field is required and show error
        if (fileUploadInput.hasAttribute('required')) {
            const fileUploadError = document.getElementById('file-upload-error');
            if (fileUploadError) {
                const errorMsg = fileUploadError.getAttribute('data-error') || 'File upload is required';
                fileUploadError.textContent = errorMsg;
                updateLabelErrorState('file-upload', true);
            }
        }
    } else {
        handleFileUpload();
    }
    
    saveFormData();
}

// Remove uploaded file by index from uploadedFilesData
function removeUploadedFile(index) {
    if (index < 0 || index >= uploadedFilesData.length) return;
    
    // Remove from data array
    uploadedFilesData.splice(index, 1);
    
    // Rebuild the file list UI
    rebuildUploadedFilesList();
    
    // Update the display
    if (uploadedFilesData.length === 0) {
        if (uploadedFilesSection) uploadedFilesSection.style.display = 'none';
        
        // Check if field is required and show error
        if (fileUploadInput && fileUploadInput.hasAttribute('required')) {
            const fileUploadError = document.getElementById('file-upload-error');
            if (fileUploadError) {
                const errorMsg = fileUploadError.getAttribute('data-error') || 'File upload is required';
                fileUploadError.textContent = errorMsg;
                updateLabelErrorState('file-upload', true);
            }
        }
    }
    
    saveFormData();
}

// Rebuild the uploaded files list UI from uploadedFilesData
function rebuildUploadedFilesList() {
    if (!uploadedFilesList) return;
    
    uploadedFilesList.innerHTML = '';
    
    uploadedFilesData.forEach((fileData, index) => {
        const fileItem = document.createElement('div');
        fileItem.className = 'uploaded-file-item';
        
        const isImage = fileData.type && fileData.type.startsWith('image/');
        const originalSizeKB = fileData.size ? (fileData.size / 1024).toFixed(0) : '?';
        const compressedSizeKB = fileData.compressedSize ? (fileData.compressedSize / 1024).toFixed(0) : originalSizeKB;
        const sizeInfo = isImage && fileData.compressedSize ? 
            `<span class="file-size-info">${originalSizeKB}KB → ${compressedSizeKB}KB</span>` : 
            `<span class="file-size-info">${originalSizeKB}KB</span>`;
        
        fileItem.innerHTML = `
            ${isImage ? `<img src="${fileData.url}" class="uploaded-file-preview" width="150"/>` : `<div class="uploaded-file-icon">📄</div>`}
            <div class="uploaded-file-details">
                <span class="uploaded-file-name">${fileData.name}</span>
                ${sizeInfo}
            </div>
            <a href="#" class="remove-file-link" data-file-index="${index}">Remove</a>
        `;
        uploadedFilesList.appendChild(fileItem);
        
        // Add remove functionality
        const removeLink = fileItem.querySelector('.remove-file-link');
        removeLink.addEventListener('click', function(e) {
            e.preventDefault();
            removeUploadedFile(index);
        });
    });
}

// Get form data
function getFormData() {
    return {
        name: nameInput.value.trim(),
        email: emailInput.value.trim(),
        country: countrySelect.value,
        supplying_my_own_shoe: supplying_my_own_shoe ? supplying_my_own_shoe.value : '',
        selectedSneaker: selectedSneakerInput ? selectedSneakerInput.value : '',
        sneakerType: sneakerTypeSelect ? sneakerTypeSelect.value : '',
        sneakerCategory: sneakerCategorySelect ? sneakerCategorySelect.value : '',
        sneakerBrand: sneakerBrandSelect ? sneakerBrandSelect.value : '',
        sneakerSilhouette: sneakerSilhouetteSelect ? sneakerSilhouetteSelect.value : '',
        shoe_type_other_opt: shoe_type_other_opt ? shoe_type_other_opt.value : '',
        color: (colorOtherInput && colorOtherInput.style.display !== 'none') ? colorOtherInput.value : (colorSelect ? colorSelect.value : ''),
        preferencesBudget: preferencesBudgetSelect ? preferencesBudgetSelect.value : '',
        gender: genderSelect ? genderSelect.value : '',
        size: sizeSelect ? sizeSelect.value : '',
        theme: themeSelect ? themeSelect.value : '',
        subtheme: subthemeSelect ? subthemeSelect.value : '',
        additionalText: additionalTextTextarea ? additionalTextTextarea.value.trim() : '',
        // Use uploadedFilesData which contains permanent URLs from the server
        additionalFiles: uploadedFilesData && uploadedFilesData.length > 0
            ? uploadedFilesData.map(f => f.name).join(', ')
            : '',
        additionalFileUrls: uploadedFilesData && uploadedFilesData.length > 0
            ? uploadedFilesData.map(f => f.url)
            : []
    };
}

function createTextField(name, value) {
    const sanitizedValue = (value || '').trim();
    if (!sanitizedValue) return null;
    return {
        name,
        type: 'text',
        value: sanitizedValue
    };
}

function createOptionsField(name, value) {
    const sanitizedValue = (value || '').trim();
    if (!sanitizedValue) return null;
    return {
        name,
        type: 'options',
        options: [sanitizedValue]
    };
}
function createImageField(name, fileData) {
  if (!fileData || !fileData.url) return null;

  return {
    name: name,              // "Attachments"
    type: 'image',
    url: fileData.url        // Use permanent URL from server
  };
}

function createImageFields(name, fileInput) {
  // Use uploadedFilesData which contains permanent URLs from the server
  if (!uploadedFilesData || uploadedFilesData.length === 0) {
    return [];
  }

  return uploadedFilesData
    .map(fileData => createImageField(name, fileData))
    .filter(Boolean);
}

function buildSubmissionPayload(formValues) {
    console.log('Building payload with', uploadedFilesData.length, 'uploaded files');
    
    const imageFields = createImageFields('Attachments', fileUploadInput);
    console.log('Image fields created:', imageFields.length, 'fields');
    
    const fields = [
        createTextField('Name', formValues.name),
        createTextField('Email', formValues.email),
        createOptionsField('Country', formValues.country),
        createTextField('Selected Sneaker', formValues.selectedSneaker),
        createTextField('I am supplying my own shoe', formValues.supplying_my_own_shoe),
        createTextField('Other', formValues.shoe_type_other_opt),
        createOptionsField('Sneaker Type', formValues.sneakerType),
        createOptionsField('Sneaker Category', formValues.sneakerCategory),
        createOptionsField('Sneaker Brand', formValues.sneakerBrand),
        createOptionsField('Sneaker Silhouette', formValues.sneakerSilhouette),
        createOptionsField('Color', formValues.color),
        createOptionsField('Budget', formValues.preferencesBudget),
        createOptionsField('Gender', formValues.gender || formValues.locale),
        createOptionsField('Size', formValues.size),
        createOptionsField('Category', formValues.theme),
        createOptionsField('Sub Category', formValues.subtheme),
        createTextField('Additional Details', formValues.additionalText),
        ...imageFields
    ].filter(Boolean);

    console.log('Total fields in payload:', fields.length);
    
    const payload = {
        customerId: resolveCustomerId(),
        vendor: getVendorName(),
        fields
    };
    
    // Calculate payload size
    const payloadJSON = JSON.stringify(payload);
    const payloadSizeKB = (payloadJSON.length / 1024).toFixed(2);
    const payloadSizeMB = (payloadJSON.length / 1024 / 1024).toFixed(2);
    
    console.log(`Payload size: ${payloadSizeKB}KB (${payloadSizeMB}MB)`);
    
    if (payloadJSON.length > 10 * 1024 * 1024) { // 10MB limit
        console.warn('⚠️ Payload is very large (>10MB). May fail to send.');
    }

    return payload;
}


// Save form data to session storage
function saveFormData() {
    const formData = getFormData();
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
    } catch (e) {
        console.error('Failed to save form data:', e);
    }
}

// Load form data from session storage
function loadFormData() {
    try {
        const saved = sessionStorage.getItem(STORAGE_KEY);
        if (saved) {
            const formData = JSON.parse(saved);
            if (formData.name) nameInput.value = formData.name;
            if (formData.email) emailInput.value = formData.email;
            if (formData.country) {
                countrySelect.value = formData.country;
                updateCountryFlag();
            }
            if (selectedSneakerInput && formData.selectedSneaker) {
                selectedSneakerInput.value = formData.selectedSneaker;
                // Restore selected state on sneaker images
                if (sneakerGrid) {
                    const sneakerCards = sneakerGrid.querySelectorAll('.sneaker-card');
                    sneakerCards.forEach(card => {
                        if (card.getAttribute('data-sneaker-name') === formData.selectedSneaker) {
                            const imageElement = card.querySelector('.sneaker-image');
                            if (imageElement) {
                                imageElement.classList.add('selected');
                            }
                        }
                    });
                }
            }
            if (sneakerTypeSelect && formData.sneakerType) {
              sneakerTypeSelect.value = formData.sneakerType;
              updateCategoryOptions(formData.sneakerType);
              const isDirectBrand = formData.sneakerType === 'Sneakers';
              
              if (formData.sneakerCategory && sneakerCategorySelect) {
                sneakerCategorySelect.value = formData.sneakerCategory;
                
                if (isDirectBrand) {
                  // For Sneakers, category IS the brand, so show silhouette directly
                  if (sneakerBrandSelect) {
                    sneakerBrandSelect.value = formData.sneakerCategory;
                  }
                  updateSilhouetteOptions(formData.sneakerCategory);
                  if (formData.sneakerSilhouette && sneakerSilhouetteSelect) {
                    sneakerSilhouetteSelect.value = formData.sneakerSilhouette;
                  }
                } else {
                  // For Sports Shoes and Lifestyle, show brand field
                  updateBrandOptions(formData.sneakerCategory);
                  if (formData.sneakerBrand && sneakerBrandSelect) {
                    sneakerBrandSelect.value = formData.sneakerBrand;
                    updateSilhouetteOptions(formData.sneakerBrand);
                    if (formData.sneakerSilhouette && sneakerSilhouetteSelect) {
                      sneakerSilhouetteSelect.value = formData.sneakerSilhouette;
                    }
                  }
                }
              }
            }
            if (colorSelect && formData.color) {
                const colorValue = formData.color.toLowerCase();
                // Check if it's a predefined option (black, white) or "other"
                const predefinedOptions = ['black', 'white', 'other'];
                if (predefinedOptions.includes(colorValue)) {
                    colorSelect.value = formData.color;
                    handleColorFieldChange();
                } else {
                    // It's a custom color, set to "other" and show input
                    colorSelect.value = 'other';
                    handleColorFieldChange();
                    if (colorOtherInput) {
                        colorOtherInput.value = formData.color;
                    }
                }
            }
            if (preferencesBudgetSelect && formData.preferencesBudget) preferencesBudgetSelect.value = formData.preferencesBudget;
            if (genderSelect && formData.gender) {
              genderSelect.value = formData.gender;
              updateSizeOptions(formData.gender);
              if (formData.size && sizeSelect) {
                sizeSelect.value = formData.size;
              }
            } else if (genderSelect && formData.locale) {
              // Backward compatibility with old 'locale' field name
              genderSelect.value = formData.locale;
              updateSizeOptions(formData.locale);
              if (formData.size && sizeSelect) {
                sizeSelect.value = formData.size;
              }
            }
            if (sizeSelect && formData.size) sizeSelect.value = formData.size;
            if (themeSelect && formData.theme) {
                themeSelect.value = formData.theme;
                handleSubthemeVisibility(); // This will populate subthemes based on selected theme
                // Set subtheme value after subthemes are populated
                if (subthemeSelect && formData.subtheme) {
                    subthemeSelect.value = formData.subtheme;
                }
            }
            if (additionalTextTextarea && formData.additionalText) additionalTextTextarea.value = formData.additionalText;
        }
    } catch (e) {
        console.error('Failed to load form data:', e);
    }
}

// Clear form data
function clearFormData() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
        nameInput.value = '';
        emailInput.value = '';
        countrySelect.value = '';
        if (selectedSneakerInput) {
            selectedSneakerInput.value = '';
            // Clear selected state on sneaker cards
            if (sneakerGrid) {
                const sneakerCards = sneakerGrid.querySelectorAll('.sneaker-card');
                sneakerCards.forEach(card => card.classList.remove('selected'));
            }
        }
        if (sneakerTypeSelect) {
          sneakerTypeSelect.value = '';
          updateCategoryOptions('');
        }
        if (sneakerCategorySelect) sneakerCategorySelect.value = '';
        if (sneakerBrandSelect) sneakerBrandSelect.value = '';
        if (sneakerSilhouetteSelect) sneakerSilhouetteSelect.value = '';
        if (colorSelect) {
            colorSelect.value = '';
            handleColorFieldChange();
        }
        if (colorOtherInput) colorOtherInput.value = '';
        if (preferencesBudgetSelect) preferencesBudgetSelect.value = '';
        if (genderSelect) {
          genderSelect.value = '';
          updateSizeOptions('');
        }
        if (sizeSelect) sizeSelect.value = '';
        if (themeSelect) {
            themeSelect.value = '';
            handleSubthemeVisibility();
        }
        if (subthemeSelect) subthemeSelect.value = '';
        if (additionalTextTextarea) additionalTextTextarea.value = '';
        if (fileUploadInput) {
            fileUploadInput.value = '';
            if (uploadedFilesList) uploadedFilesList.innerHTML = '';
            if (uploadedFilesSection) uploadedFilesSection.style.display = 'none';
        }
        // Clear uploaded files data array
        uploadedFilesData = [];
    } catch (e) {
        console.error('Failed to clear form data:', e);
    }
}

// Update review step
function updateReviewStep() {
    const formData = getFormData();
    
    // Personal Information
    if (reviewName) reviewName.textContent = formData.name || 'Not provided';
    if (reviewEmail) reviewEmail.textContent = formData.email || 'Not provided';
    if (reviewCountry) reviewCountry.textContent = formData.country ? (COUNTRIES_BY_CODE[formData.country] || formData.country) : 'Not provided';
    
    // Sneaker Selection
    if (reviewSelectedSneaker) reviewSelectedSneaker.textContent = formData.selectedSneaker || 'Not provided';
    if (reviewSneakerType) reviewSneakerType.textContent = formData.sneakerType || 'Not provided';
    if (reviewSneakerCategory) reviewSneakerCategory.textContent = formData.sneakerCategory || 'Not provided';
    if (reviewSneakerBrand) reviewSneakerBrand.textContent = formData.sneakerBrand || 'Not provided';
    if (reviewSneakerSilhouette) reviewSneakerSilhouette.textContent = formData.sneakerSilhouette || 'Not provided';
    
    // Get sneaker image from selected card
    if (formData.selectedSneaker && sneakerGrid) {
        const selectedCard = sneakerGrid.querySelector(`[data-sneaker-name="${formData.selectedSneaker}"]`);
        if (selectedCard) {
            const sneakerImageUrl = selectedCard.getAttribute('data-sneaker-image');
            if (sneakerImageUrl && sneakerImageUrl.trim() !== '') {
                if (reviewSneakerImage) {
                    reviewSneakerImage.src = sneakerImageUrl;
                    if (sneakerImageThanks) {
                        sneakerImageThanks.src = sneakerImageUrl;
                    }
                    reviewSneakerImage.style.display = 'block';
                    if (reviewSneakerImagePlaceholder) reviewSneakerImagePlaceholder.style.display = 'none';
                }
            } else {
                if (reviewSneakerImage) reviewSneakerImage.style.display = 'none';
                if (reviewSneakerImagePlaceholder) {
                    reviewSneakerImagePlaceholder.style.display = 'block';
                }
            }
        } else {
            if (reviewSneakerImage) reviewSneakerImage.style.display = 'none';
            if (reviewSneakerImagePlaceholder) reviewSneakerImagePlaceholder.style.display = 'none';
        }
    } else {
        if (reviewSneakerImage) reviewSneakerImage.style.display = 'none';
        if (reviewSneakerImagePlaceholder) reviewSneakerImagePlaceholder.style.display = 'none';
    }

    // Show or hide the entire image container depending on whether we have an image or placeholder visible
    try {
        let hasVisible = false;
        if (reviewSneakerImage && reviewSneakerImage.style.display !== 'none') hasVisible = true;
        if (reviewSneakerImagePlaceholder && reviewSneakerImagePlaceholder.style.display !== 'none') hasVisible = true;
        if (reviewSneakerImageContainer) {
            reviewSneakerImageContainer.style.display = hasVisible ? '' : 'none';
        }
    } catch (e) {
        // ignore
    }
    
    // Styling Preferences
    if (reviewColor) reviewColor.textContent = formData.color || 'Not provided';
    if (reviewSize) reviewSize.textContent = formData.size || 'Not provided';
    
    // Format budget from preferences step
    if (reviewBudget) {
        const budgetValue = formData.preferencesBudget || '';
        if (budgetValue) {
            // Try to get display name from select option
            const budgetSelect = document.getElementById('preferences-budget');
            if (budgetSelect) {
                const selectedOption = budgetSelect.querySelector(`option[value="${budgetValue}"]`);
                if (selectedOption && selectedOption.textContent) {
                    reviewBudget.textContent = selectedOption.textContent.trim();
                } else {
                    reviewBudget.textContent = budgetValue;
                }
            } else {
                reviewBudget.textContent = budgetValue;
            }
        } else {
            reviewBudget.textContent = 'Not provided';
        }
    }
    
    if (reviewTheme) {
        const themeValue = formData.theme || '';
        if (themeValue) {
            const themeSelect = document.getElementById('theme');
            if (themeSelect) {
                const selectedOption = themeSelect.querySelector(`option[value="${themeValue}"]`);
                if (selectedOption && selectedOption.textContent) {
                    reviewTheme.textContent = selectedOption.textContent.trim();
                } else {
                    reviewTheme.textContent = themeValue;
                }
            } else {
                reviewTheme.textContent = themeValue;
            }
        } else {
            reviewTheme.textContent = 'Not provided';
        }
    }

    if (subCategory) {
        const subThemeValue = formData.subtheme || '';
        if (subThemeValue) {
            const themeSelect = document.getElementById('subtheme');
            if (themeSelect) {
                const subselectedOption = themeSelect.querySelector(`option[value="${subThemeValue}"]`);
                console.log(subselectedOption)
                if (subselectedOption && subselectedOption.textContent) {
                    subCategory.textContent = subselectedOption.textContent.trim();
                } else {
                    subCategory.textContent = subThemeValue;
                }
            } else {
                subCategory.textContent = subThemeValue;
            }
        } else {
            subCategory.textContent = 'Not provided';
        }
    }
    
    // Additional Details
    if (reviewAdditionalText) reviewAdditionalText.textContent = formData.additionalText || 'Not provided';
    
    // Display uploaded files from uploadedFilesData (uses base64 URLs)
    if (reviewAttachments && reviewAttachmentsField) {
        if (uploadedFilesData && uploadedFilesData.length > 0) {
            reviewAttachments.innerHTML = '';

            uploadedFilesData.forEach(fileData => {
                const fileItem = document.createElement('div');
                fileItem.className = 'review-attachment-item';
                fileItem.style.width = '150px';
                fileItem.style.marginTop = '10px';
                
                const isImage = fileData.type && fileData.type.startsWith('image/');

                if (isImage) {
                    const img = document.createElement('img');
                    img.className = 'review-attachment-preview';
                    img.src = fileData.url; // Use base64 data URL
                    img.alt = fileData.name;

                    // click image → download
                    img.addEventListener('click', () => {
                        const a = document.createElement('a');
                        a.href = fileData.url;
                        a.download = fileData.name;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    });

                    fileItem.appendChild(img);
                } else {
                    // fallback for non-images (keep your icon + name)
                    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    icon.setAttribute('class', 'review-attachment-icon');
                    icon.setAttribute('viewBox', '0 0 16 16');
                    icon.setAttribute('fill', 'currentColor');
                    icon.innerHTML =
                        '<path d="M10.5 0H3.5C2.67 0 2 .67 2 1.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V4.5L10.5 0z"/>';

                    const link = document.createElement('span');
                    link.textContent = fileData.name;

                    fileItem.appendChild(icon);
                    fileItem.appendChild(link);
                }

                reviewAttachments.appendChild(fileItem);
            });

            reviewAttachmentsField.style.display = 'block';
        } else {
            reviewAttachmentsField.style.display = 'none';
        }
    }

}

// Update URL with current step
function updateURL() {
    const url = new URL(window.location);
    url.searchParams.set('step', currentStep.toString());
    window.history.replaceState({}, '', url);
}

// Show notification (simple alert for now - you can replace with a toast library)
function showNotification(message, type) {
    // Simple implementation - you can replace with a toast library
    if (type === 'error') {
        alert('Error: ' + message);
    } else {
        alert(message);
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}